<template>
    <div class="circles-container">
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
        <div class="circle-container">
            <div class="circle"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnimatedCircles'
}
</script>

<style lang="sass" scoped>
.circle-container 
  position: absolute
  -webkit-transform: translateY(-10vh)
          transform: translateY(-10vh)
  -webkit-animation-iteration-count: infinite
          animation-iteration-count: infinite
  -webkit-animation-timing-function: linear
          animation-timing-function: linear

.circle-container .circle 
  width: 100%
  height: 100%
  border-radius: 50%
  mix-blend-mode: screen
  background-image: radial-gradient(#99ffff, #99ffff 10%, rgba(153, 255, 255, 0) 56%)
  -webkit-animation: fadein-frames 200ms infinite, scale-frames 2s infinite
          animation: fadein-frames 200ms infinite, scale-frames 2s infinite

@-webkit-keyframes fade-frames 
  0% 
    opacity: 1
  
  50% 
    opacity: 0.7
  
  100% 
    opacity: 1
  

@keyframes fade-frames 
  0% 
    opacity: 1
  
  50% 
    opacity: 0.7
  
  100% 
    opacity: 1
  

@-webkit-keyframes scale-frames 
  0% 
    -webkit-transform: scale3d(0.4, 0.4, 1)
            transform: scale3d(0.4, 0.4, 1)
  
  50% 
    -webkit-transform: scale3d(2.2, 2.2, 1)
            transform: scale3d(2.2, 2.2, 1)
  
  100% 
    -webkit-transform: scale3d(0.4, 0.4, 1)
            transform: scale3d(0.4, 0.4, 1)
  

@keyframes scale-frames 
  0% 
    -webkit-transform: scale3d(0.4, 0.4, 1)
            transform: scale3d(0.4, 0.4, 1)
  
  50% 
    -webkit-transform: scale3d(2.2, 2.2, 1)
            transform: scale3d(2.2, 2.2, 1)
  
  100% 
    -webkit-transform: scale3d(0.4, 0.4, 1)
            transform: scale3d(0.4, 0.4, 1)
  

.circle-container:nth-child(1) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-1
          animation-name: move-frames-1
  -webkit-animation-duration: 31629ms
          animation-duration: 31629ms
  -webkit-animation-delay: 16888ms
          animation-delay: 16888ms

@-webkit-keyframes move-frames-1 
  from 
    -webkit-transform: translate3d(95vw, 105vh, 0)
            transform: translate3d(95vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(17vw, -109vh, 0)
            transform: translate3d(17vw, -109vh, 0)
  

@keyframes move-frames-1 
  from 
    -webkit-transform: translate3d(95vw, 105vh, 0)
            transform: translate3d(95vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(17vw, -109vh, 0)
            transform: translate3d(17vw, -109vh, 0)
  

.circle-container:nth-child(1) .circle 
  -webkit-animation-delay: 3101ms
          animation-delay: 3101ms

.circle-container:nth-child(2) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-2
          animation-name: move-frames-2
  -webkit-animation-duration: 29829ms
          animation-duration: 29829ms
  -webkit-animation-delay: 28802ms
          animation-delay: 28802ms

@-webkit-keyframes move-frames-2 
  from 
    -webkit-transform: translate3d(34vw, 108vh, 0)
            transform: translate3d(34vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(81vw, -134vh, 0)
            transform: translate3d(81vw, -134vh, 0)
  

@keyframes move-frames-2 
  from 
    -webkit-transform: translate3d(34vw, 108vh, 0)
            transform: translate3d(34vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(81vw, -134vh, 0)
            transform: translate3d(81vw, -134vh, 0)
  

.circle-container:nth-child(2) .circle 
  -webkit-animation-delay: 2865ms
          animation-delay: 2865ms

.circle-container:nth-child(3) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-3
          animation-name: move-frames-3
  -webkit-animation-duration: 31166ms
          animation-duration: 31166ms
  -webkit-animation-delay: 26856ms
          animation-delay: 26856ms

@-webkit-keyframes move-frames-3 
  from 
    -webkit-transform: translate3d(52vw, 108vh, 0)
            transform: translate3d(52vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -133vh, 0)
            transform: translate3d(41vw, -133vh, 0)
  

@keyframes move-frames-3 
  from 
    -webkit-transform: translate3d(52vw, 108vh, 0)
            transform: translate3d(52vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -133vh, 0)
            transform: translate3d(41vw, -133vh, 0)
  

.circle-container:nth-child(3) .circle 
  -webkit-animation-delay: 3469ms
          animation-delay: 3469ms

.circle-container:nth-child(4) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-4
          animation-name: move-frames-4
  -webkit-animation-duration: 31210ms
          animation-duration: 31210ms
  -webkit-animation-delay: 3816ms
          animation-delay: 3816ms

@-webkit-keyframes move-frames-4 
  from 
    -webkit-transform: translate3d(29vw, 101vh, 0)
            transform: translate3d(29vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -103vh, 0)
            transform: translate3d(47vw, -103vh, 0)
  

@keyframes move-frames-4 
  from 
    -webkit-transform: translate3d(29vw, 101vh, 0)
            transform: translate3d(29vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -103vh, 0)
            transform: translate3d(47vw, -103vh, 0)
  

.circle-container:nth-child(4) .circle 
  -webkit-animation-delay: 3947ms
          animation-delay: 3947ms

.circle-container:nth-child(5) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-5
          animation-name: move-frames-5
  -webkit-animation-duration: 32610ms
          animation-duration: 32610ms
  -webkit-animation-delay: 12936ms
          animation-delay: 12936ms

@-webkit-keyframes move-frames-5 
  from 
    -webkit-transform: translate3d(20vw, 104vh, 0)
            transform: translate3d(20vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -131vh, 0)
            transform: translate3d(76vw, -131vh, 0)
  

@keyframes move-frames-5 
  from 
    -webkit-transform: translate3d(20vw, 104vh, 0)
            transform: translate3d(20vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -131vh, 0)
            transform: translate3d(76vw, -131vh, 0)
  

.circle-container:nth-child(5) .circle 
  -webkit-animation-delay: 554ms
          animation-delay: 554ms

.circle-container:nth-child(6) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-6
          animation-name: move-frames-6
  -webkit-animation-duration: 36741ms
          animation-duration: 36741ms
  -webkit-animation-delay: 16650ms
          animation-delay: 16650ms

@-webkit-keyframes move-frames-6 
  from 
    -webkit-transform: translate3d(40vw, 102vh, 0)
            transform: translate3d(40vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(6vw, -117vh, 0)
            transform: translate3d(6vw, -117vh, 0)
  

@keyframes move-frames-6 
  from 
    -webkit-transform: translate3d(40vw, 102vh, 0)
            transform: translate3d(40vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(6vw, -117vh, 0)
            transform: translate3d(6vw, -117vh, 0)
  

.circle-container:nth-child(6) .circle 
  -webkit-animation-delay: 2052ms
          animation-delay: 2052ms

.circle-container:nth-child(7) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-7
          animation-name: move-frames-7
  -webkit-animation-duration: 32297ms
          animation-duration: 32297ms
  -webkit-animation-delay: 33610ms
          animation-delay: 33610ms

@-webkit-keyframes move-frames-7 
  from 
    -webkit-transform: translate3d(76vw, 109vh, 0)
            transform: translate3d(76vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(23vw, -117vh, 0)
            transform: translate3d(23vw, -117vh, 0)
  

@keyframes move-frames-7 
  from 
    -webkit-transform: translate3d(76vw, 109vh, 0)
            transform: translate3d(76vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(23vw, -117vh, 0)
            transform: translate3d(23vw, -117vh, 0)
  

.circle-container:nth-child(7) .circle 
  -webkit-animation-delay: 347ms
          animation-delay: 347ms

.circle-container:nth-child(8) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-8
          animation-name: move-frames-8
  -webkit-animation-duration: 30947ms
          animation-duration: 30947ms
  -webkit-animation-delay: 16143ms
          animation-delay: 16143ms

@-webkit-keyframes move-frames-8 
  from 
    -webkit-transform: translate3d(6vw, 107vh, 0)
            transform: translate3d(6vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -135vh, 0)
            transform: translate3d(42vw, -135vh, 0)
  

@keyframes move-frames-8 
  from 
    -webkit-transform: translate3d(6vw, 107vh, 0)
            transform: translate3d(6vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -135vh, 0)
            transform: translate3d(42vw, -135vh, 0)
  

.circle-container:nth-child(8) .circle 
  -webkit-animation-delay: 492ms
          animation-delay: 492ms

.circle-container:nth-child(9) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-9
          animation-name: move-frames-9
  -webkit-animation-duration: 31436ms
          animation-duration: 31436ms
  -webkit-animation-delay: 23328ms
          animation-delay: 23328ms

@-webkit-keyframes move-frames-9 
  from 
    -webkit-transform: translate3d(86vw, 101vh, 0)
            transform: translate3d(86vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(71vw, -104vh, 0)
            transform: translate3d(71vw, -104vh, 0)
  

@keyframes move-frames-9 
  from 
    -webkit-transform: translate3d(86vw, 101vh, 0)
            transform: translate3d(86vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(71vw, -104vh, 0)
            transform: translate3d(71vw, -104vh, 0)
  

.circle-container:nth-child(9) .circle 
  -webkit-animation-delay: 1387ms
          animation-delay: 1387ms

.circle-container:nth-child(10) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-10
          animation-name: move-frames-10
  -webkit-animation-duration: 33449ms
          animation-duration: 33449ms
  -webkit-animation-delay: 26386ms
          animation-delay: 26386ms

@-webkit-keyframes move-frames-10 
  from 
    -webkit-transform: translate3d(68vw, 109vh, 0)
            transform: translate3d(68vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(33vw, -115vh, 0)
            transform: translate3d(33vw, -115vh, 0)
  

@keyframes move-frames-10 
  from 
    -webkit-transform: translate3d(68vw, 109vh, 0)
            transform: translate3d(68vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(33vw, -115vh, 0)
            transform: translate3d(33vw, -115vh, 0)
  

.circle-container:nth-child(10) .circle 
  -webkit-animation-delay: 3979ms
          animation-delay: 3979ms

.circle-container:nth-child(11) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-11
          animation-name: move-frames-11
  -webkit-animation-duration: 28278ms
          animation-duration: 28278ms
  -webkit-animation-delay: 32831ms
          animation-delay: 32831ms

@-webkit-keyframes move-frames-11 
  from 
    -webkit-transform: translate3d(24vw, 104vh, 0)
            transform: translate3d(24vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(84vw, -120vh, 0)
            transform: translate3d(84vw, -120vh, 0)
  

@keyframes move-frames-11 
  from 
    -webkit-transform: translate3d(24vw, 104vh, 0)
            transform: translate3d(24vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(84vw, -120vh, 0)
            transform: translate3d(84vw, -120vh, 0)
  

.circle-container:nth-child(11) .circle 
  -webkit-animation-delay: 3046ms
          animation-delay: 3046ms

.circle-container:nth-child(12) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-12
          animation-name: move-frames-12
  -webkit-animation-duration: 30459ms
          animation-duration: 30459ms
  -webkit-animation-delay: 164ms
          animation-delay: 164ms

@-webkit-keyframes move-frames-12 
  from 
    -webkit-transform: translate3d(53vw, 109vh, 0)
            transform: translate3d(53vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(74vw, -134vh, 0)
            transform: translate3d(74vw, -134vh, 0)
  

@keyframes move-frames-12 
  from 
    -webkit-transform: translate3d(53vw, 109vh, 0)
            transform: translate3d(53vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(74vw, -134vh, 0)
            transform: translate3d(74vw, -134vh, 0)
  

.circle-container:nth-child(12) .circle 
  -webkit-animation-delay: 299ms
          animation-delay: 299ms

.circle-container:nth-child(13) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-13
          animation-name: move-frames-13
  -webkit-animation-duration: 33610ms
          animation-duration: 33610ms
  -webkit-animation-delay: 24288ms
          animation-delay: 24288ms

@-webkit-keyframes move-frames-13 
  from 
    -webkit-transform: translate3d(88vw, 110vh, 0)
            transform: translate3d(88vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(44vw, -113vh, 0)
            transform: translate3d(44vw, -113vh, 0)
  

@keyframes move-frames-13 
  from 
    -webkit-transform: translate3d(88vw, 110vh, 0)
            transform: translate3d(88vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(44vw, -113vh, 0)
            transform: translate3d(44vw, -113vh, 0)
  

.circle-container:nth-child(13) .circle 
  -webkit-animation-delay: 2418ms
          animation-delay: 2418ms

.circle-container:nth-child(14) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-14
          animation-name: move-frames-14
  -webkit-animation-duration: 34941ms
          animation-duration: 34941ms
  -webkit-animation-delay: 15658ms
          animation-delay: 15658ms

@-webkit-keyframes move-frames-14 
  from 
    -webkit-transform: translate3d(45vw, 110vh, 0)
            transform: translate3d(45vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(25vw, -127vh, 0)
            transform: translate3d(25vw, -127vh, 0)
  

@keyframes move-frames-14 
  from 
    -webkit-transform: translate3d(45vw, 110vh, 0)
            transform: translate3d(45vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(25vw, -127vh, 0)
            transform: translate3d(25vw, -127vh, 0)
  

.circle-container:nth-child(14) .circle 
  -webkit-animation-delay: 1331ms
          animation-delay: 1331ms

.circle-container:nth-child(15) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-15
          animation-name: move-frames-15
  -webkit-animation-duration: 36241ms
          animation-duration: 36241ms
  -webkit-animation-delay: 12834ms
          animation-delay: 12834ms

@-webkit-keyframes move-frames-15 
  from 
    -webkit-transform: translate3d(89vw, 105vh, 0)
            transform: translate3d(89vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(54vw, -129vh, 0)
            transform: translate3d(54vw, -129vh, 0)
  

@keyframes move-frames-15 
  from 
    -webkit-transform: translate3d(89vw, 105vh, 0)
            transform: translate3d(89vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(54vw, -129vh, 0)
            transform: translate3d(54vw, -129vh, 0)
  

.circle-container:nth-child(15) .circle 
  -webkit-animation-delay: 691ms
          animation-delay: 691ms

.circle-container:nth-child(16) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-16
          animation-name: move-frames-16
  -webkit-animation-duration: 35626ms
          animation-duration: 35626ms
  -webkit-animation-delay: 24426ms
          animation-delay: 24426ms

@-webkit-keyframes move-frames-16 
  from 
    -webkit-transform: translate3d(54vw, 109vh, 0)
            transform: translate3d(54vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(39vw, -126vh, 0)
            transform: translate3d(39vw, -126vh, 0)
  

@keyframes move-frames-16 
  from 
    -webkit-transform: translate3d(54vw, 109vh, 0)
            transform: translate3d(54vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(39vw, -126vh, 0)
            transform: translate3d(39vw, -126vh, 0)
  

.circle-container:nth-child(16) .circle 
  -webkit-animation-delay: 2272ms
          animation-delay: 2272ms

.circle-container:nth-child(17) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-17
          animation-name: move-frames-17
  -webkit-animation-duration: 32811ms
          animation-duration: 32811ms
  -webkit-animation-delay: 17578ms
          animation-delay: 17578ms

@-webkit-keyframes move-frames-17 
  from 
    -webkit-transform: translate3d(78vw, 110vh, 0)
            transform: translate3d(78vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -137vh, 0)
            transform: translate3d(30vw, -137vh, 0)
  

@keyframes move-frames-17 
  from 
    -webkit-transform: translate3d(78vw, 110vh, 0)
            transform: translate3d(78vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -137vh, 0)
            transform: translate3d(30vw, -137vh, 0)
  

.circle-container:nth-child(17) .circle 
  -webkit-animation-delay: 2393ms
          animation-delay: 2393ms

.circle-container:nth-child(18) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-18
          animation-name: move-frames-18
  -webkit-animation-duration: 30193ms
          animation-duration: 30193ms
  -webkit-animation-delay: 2509ms
          animation-delay: 2509ms

@-webkit-keyframes move-frames-18 
  from 
    -webkit-transform: translate3d(67vw, 106vh, 0)
            transform: translate3d(67vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(78vw, -110vh, 0)
            transform: translate3d(78vw, -110vh, 0)
  

@keyframes move-frames-18 
  from 
    -webkit-transform: translate3d(67vw, 106vh, 0)
            transform: translate3d(67vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(78vw, -110vh, 0)
            transform: translate3d(78vw, -110vh, 0)
  

.circle-container:nth-child(18) .circle 
  -webkit-animation-delay: 810ms
          animation-delay: 810ms

.circle-container:nth-child(19) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-19
          animation-name: move-frames-19
  -webkit-animation-duration: 33583ms
          animation-duration: 33583ms
  -webkit-animation-delay: 7279ms
          animation-delay: 7279ms

@-webkit-keyframes move-frames-19 
  from 
    -webkit-transform: translate3d(55vw, 108vh, 0)
            transform: translate3d(55vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(48vw, -132vh, 0)
            transform: translate3d(48vw, -132vh, 0)
  

@keyframes move-frames-19 
  from 
    -webkit-transform: translate3d(55vw, 108vh, 0)
            transform: translate3d(55vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(48vw, -132vh, 0)
            transform: translate3d(48vw, -132vh, 0)
  

.circle-container:nth-child(19) .circle 
  -webkit-animation-delay: 1112ms
          animation-delay: 1112ms

.circle-container:nth-child(20) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-20
          animation-name: move-frames-20
  -webkit-animation-duration: 36573ms
          animation-duration: 36573ms
  -webkit-animation-delay: 24154ms
          animation-delay: 24154ms

@-webkit-keyframes move-frames-20 
  from 
    -webkit-transform: translate3d(59vw, 103vh, 0)
            transform: translate3d(59vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(4vw, -108vh, 0)
            transform: translate3d(4vw, -108vh, 0)
  

@keyframes move-frames-20 
  from 
    -webkit-transform: translate3d(59vw, 103vh, 0)
            transform: translate3d(59vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(4vw, -108vh, 0)
            transform: translate3d(4vw, -108vh, 0)
  

.circle-container:nth-child(20) .circle 
  -webkit-animation-delay: 3899ms
          animation-delay: 3899ms

.circle-container:nth-child(21) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-21
          animation-name: move-frames-21
  -webkit-animation-duration: 34467ms
          animation-duration: 34467ms
  -webkit-animation-delay: 19420ms
          animation-delay: 19420ms

@-webkit-keyframes move-frames-21 
  from 
    -webkit-transform: translate3d(29vw, 106vh, 0)
            transform: translate3d(29vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -116vh, 0)
            transform: translate3d(27vw, -116vh, 0)
  

@keyframes move-frames-21 
  from 
    -webkit-transform: translate3d(29vw, 106vh, 0)
            transform: translate3d(29vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -116vh, 0)
            transform: translate3d(27vw, -116vh, 0)
  

.circle-container:nth-child(21) .circle 
  -webkit-animation-delay: 898ms
          animation-delay: 898ms

.circle-container:nth-child(22) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-22
          animation-name: move-frames-22
  -webkit-animation-duration: 33750ms
          animation-duration: 33750ms
  -webkit-animation-delay: 17945ms
          animation-delay: 17945ms

@-webkit-keyframes move-frames-22 
  from 
    -webkit-transform: translate3d(27vw, 110vh, 0)
            transform: translate3d(27vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(9vw, -128vh, 0)
            transform: translate3d(9vw, -128vh, 0)
  

@keyframes move-frames-22 
  from 
    -webkit-transform: translate3d(27vw, 110vh, 0)
            transform: translate3d(27vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(9vw, -128vh, 0)
            transform: translate3d(9vw, -128vh, 0)
  

.circle-container:nth-child(22) .circle 
  -webkit-animation-delay: 368ms
          animation-delay: 368ms

.circle-container:nth-child(23) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-23
          animation-name: move-frames-23
  -webkit-animation-duration: 36039ms
          animation-duration: 36039ms
  -webkit-animation-delay: 31727ms
          animation-delay: 31727ms

@-webkit-keyframes move-frames-23 
  from 
    -webkit-transform: translate3d(92vw, 107vh, 0)
            transform: translate3d(92vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(51vw, -112vh, 0)
            transform: translate3d(51vw, -112vh, 0)
  

@keyframes move-frames-23 
  from 
    -webkit-transform: translate3d(92vw, 107vh, 0)
            transform: translate3d(92vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(51vw, -112vh, 0)
            transform: translate3d(51vw, -112vh, 0)
  

.circle-container:nth-child(23) .circle 
  -webkit-animation-delay: 294ms
          animation-delay: 294ms

.circle-container:nth-child(24) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-24
          animation-name: move-frames-24
  -webkit-animation-duration: 33509ms
          animation-duration: 33509ms
  -webkit-animation-delay: 23140ms
          animation-delay: 23140ms

@-webkit-keyframes move-frames-24 
  from 
    -webkit-transform: translate3d(95vw, 108vh, 0)
            transform: translate3d(95vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(66vw, -112vh, 0)
            transform: translate3d(66vw, -112vh, 0)
  

@keyframes move-frames-24 
  from 
    -webkit-transform: translate3d(95vw, 108vh, 0)
            transform: translate3d(95vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(66vw, -112vh, 0)
            transform: translate3d(66vw, -112vh, 0)
  

.circle-container:nth-child(24) .circle 
  -webkit-animation-delay: 1317ms
          animation-delay: 1317ms

.circle-container:nth-child(25) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-25
          animation-name: move-frames-25
  -webkit-animation-duration: 31384ms
          animation-duration: 31384ms
  -webkit-animation-delay: 24586ms
          animation-delay: 24586ms

@-webkit-keyframes move-frames-25 
  from 
    -webkit-transform: translate3d(5vw, 106vh, 0)
            transform: translate3d(5vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(66vw, -122vh, 0)
            transform: translate3d(66vw, -122vh, 0)
  

@keyframes move-frames-25 
  from 
    -webkit-transform: translate3d(5vw, 106vh, 0)
            transform: translate3d(5vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(66vw, -122vh, 0)
            transform: translate3d(66vw, -122vh, 0)
  

.circle-container:nth-child(25) .circle 
  -webkit-animation-delay: 2095ms
          animation-delay: 2095ms

.circle-container:nth-child(26) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-26
          animation-name: move-frames-26
  -webkit-animation-duration: 36752ms
          animation-duration: 36752ms
  -webkit-animation-delay: 16778ms
          animation-delay: 16778ms

@-webkit-keyframes move-frames-26 
  from 
    -webkit-transform: translate3d(80vw, 109vh, 0)
            transform: translate3d(80vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -118vh, 0)
            transform: translate3d(30vw, -118vh, 0)
  

@keyframes move-frames-26 
  from 
    -webkit-transform: translate3d(80vw, 109vh, 0)
            transform: translate3d(80vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -118vh, 0)
            transform: translate3d(30vw, -118vh, 0)
  

.circle-container:nth-child(26) .circle 
  -webkit-animation-delay: 3628ms
          animation-delay: 3628ms

.circle-container:nth-child(27) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-27
          animation-name: move-frames-27
  -webkit-animation-duration: 30110ms
          animation-duration: 30110ms
  -webkit-animation-delay: 19386ms
          animation-delay: 19386ms

@-webkit-keyframes move-frames-27 
  from 
    -webkit-transform: translate3d(66vw, 108vh, 0)
            transform: translate3d(66vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(18vw, -129vh, 0)
            transform: translate3d(18vw, -129vh, 0)
  

@keyframes move-frames-27 
  from 
    -webkit-transform: translate3d(66vw, 108vh, 0)
            transform: translate3d(66vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(18vw, -129vh, 0)
            transform: translate3d(18vw, -129vh, 0)
  

.circle-container:nth-child(27) .circle 
  -webkit-animation-delay: 1307ms
          animation-delay: 1307ms

.circle-container:nth-child(28) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-28
          animation-name: move-frames-28
  -webkit-animation-duration: 34011ms
          animation-duration: 34011ms
  -webkit-animation-delay: 11928ms
          animation-delay: 11928ms

@-webkit-keyframes move-frames-28 
  from 
    -webkit-transform: translate3d(86vw, 109vh, 0)
            transform: translate3d(86vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(66vw, -118vh, 0)
            transform: translate3d(66vw, -118vh, 0)
  

@keyframes move-frames-28 
  from 
    -webkit-transform: translate3d(86vw, 109vh, 0)
            transform: translate3d(86vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(66vw, -118vh, 0)
            transform: translate3d(66vw, -118vh, 0)
  

.circle-container:nth-child(28) .circle 
  -webkit-animation-delay: 715ms
          animation-delay: 715ms

.circle-container:nth-child(29) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-29
          animation-name: move-frames-29
  -webkit-animation-duration: 30318ms
          animation-duration: 30318ms
  -webkit-animation-delay: 21581ms
          animation-delay: 21581ms

@-webkit-keyframes move-frames-29 
  from 
    -webkit-transform: translate3d(23vw, 106vh, 0)
            transform: translate3d(23vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -117vh, 0)
            transform: translate3d(3vw, -117vh, 0)
  

@keyframes move-frames-29 
  from 
    -webkit-transform: translate3d(23vw, 106vh, 0)
            transform: translate3d(23vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -117vh, 0)
            transform: translate3d(3vw, -117vh, 0)
  

.circle-container:nth-child(29) .circle 
  -webkit-animation-delay: 3520ms
          animation-delay: 3520ms

.circle-container:nth-child(30) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-30
          animation-name: move-frames-30
  -webkit-animation-duration: 34903ms
          animation-duration: 34903ms
  -webkit-animation-delay: 24248ms
          animation-delay: 24248ms

@-webkit-keyframes move-frames-30 
  from 
    -webkit-transform: translate3d(93vw, 108vh, 0)
            transform: translate3d(93vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(84vw, -110vh, 0)
            transform: translate3d(84vw, -110vh, 0)
  

@keyframes move-frames-30 
  from 
    -webkit-transform: translate3d(93vw, 108vh, 0)
            transform: translate3d(93vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(84vw, -110vh, 0)
            transform: translate3d(84vw, -110vh, 0)
  

.circle-container:nth-child(30) .circle 
  -webkit-animation-delay: 1356ms
          animation-delay: 1356ms

.circle-container:nth-child(31) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-31
          animation-name: move-frames-31
  -webkit-animation-duration: 32399ms
          animation-duration: 32399ms
  -webkit-animation-delay: 20050ms
          animation-delay: 20050ms

@-webkit-keyframes move-frames-31 
  from 
    -webkit-transform: translate3d(49vw, 104vh, 0)
            transform: translate3d(49vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -112vh, 0)
            transform: translate3d(75vw, -112vh, 0)
  

@keyframes move-frames-31 
  from 
    -webkit-transform: translate3d(49vw, 104vh, 0)
            transform: translate3d(49vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -112vh, 0)
            transform: translate3d(75vw, -112vh, 0)
  

.circle-container:nth-child(31) .circle 
  -webkit-animation-delay: 2541ms
          animation-delay: 2541ms

.circle-container:nth-child(32) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-32
          animation-name: move-frames-32
  -webkit-animation-duration: 33153ms
          animation-duration: 33153ms
  -webkit-animation-delay: 30498ms
          animation-delay: 30498ms

@-webkit-keyframes move-frames-32 
  from 
    -webkit-transform: translate3d(58vw, 101vh, 0)
            transform: translate3d(58vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(74vw, -126vh, 0)
            transform: translate3d(74vw, -126vh, 0)
  

@keyframes move-frames-32 
  from 
    -webkit-transform: translate3d(58vw, 101vh, 0)
            transform: translate3d(58vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(74vw, -126vh, 0)
            transform: translate3d(74vw, -126vh, 0)
  

.circle-container:nth-child(32) .circle 
  -webkit-animation-delay: 3442ms
          animation-delay: 3442ms

.circle-container:nth-child(33) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-33
          animation-name: move-frames-33
  -webkit-animation-duration: 29403ms
          animation-duration: 29403ms
  -webkit-animation-delay: 11454ms
          animation-delay: 11454ms

@-webkit-keyframes move-frames-33 
  from 
    -webkit-transform: translate3d(98vw, 107vh, 0)
            transform: translate3d(98vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(13vw, -113vh, 0)
            transform: translate3d(13vw, -113vh, 0)
  

@keyframes move-frames-33 
  from 
    -webkit-transform: translate3d(98vw, 107vh, 0)
            transform: translate3d(98vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(13vw, -113vh, 0)
            transform: translate3d(13vw, -113vh, 0)
  

.circle-container:nth-child(33) .circle 
  -webkit-animation-delay: 1920ms
          animation-delay: 1920ms

.circle-container:nth-child(34) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-34
          animation-name: move-frames-34
  -webkit-animation-duration: 28231ms
          animation-duration: 28231ms
  -webkit-animation-delay: 1053ms
          animation-delay: 1053ms

@-webkit-keyframes move-frames-34 
  from 
    -webkit-transform: translate3d(35vw, 107vh, 0)
            transform: translate3d(35vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(88vw, -117vh, 0)
            transform: translate3d(88vw, -117vh, 0)
  

@keyframes move-frames-34 
  from 
    -webkit-transform: translate3d(35vw, 107vh, 0)
            transform: translate3d(35vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(88vw, -117vh, 0)
            transform: translate3d(88vw, -117vh, 0)
  

.circle-container:nth-child(34) .circle 
  -webkit-animation-delay: 1221ms
          animation-delay: 1221ms

.circle-container:nth-child(35) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-35
          animation-name: move-frames-35
  -webkit-animation-duration: 36199ms
          animation-duration: 36199ms
  -webkit-animation-delay: 10397ms
          animation-delay: 10397ms

@-webkit-keyframes move-frames-35 
  from 
    -webkit-transform: translate3d(34vw, 106vh, 0)
            transform: translate3d(34vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(59vw, -133vh, 0)
            transform: translate3d(59vw, -133vh, 0)
  

@keyframes move-frames-35 
  from 
    -webkit-transform: translate3d(34vw, 106vh, 0)
            transform: translate3d(34vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(59vw, -133vh, 0)
            transform: translate3d(59vw, -133vh, 0)
  

.circle-container:nth-child(35) .circle 
  -webkit-animation-delay: 585ms
          animation-delay: 585ms

.circle-container:nth-child(36) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-36
          animation-name: move-frames-36
  -webkit-animation-duration: 29696ms
          animation-duration: 29696ms
  -webkit-animation-delay: 29037ms
          animation-delay: 29037ms

@-webkit-keyframes move-frames-36 
  from 
    -webkit-transform: translate3d(18vw, 104vh, 0)
            transform: translate3d(18vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(49vw, -114vh, 0)
            transform: translate3d(49vw, -114vh, 0)
  

@keyframes move-frames-36 
  from 
    -webkit-transform: translate3d(18vw, 104vh, 0)
            transform: translate3d(18vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(49vw, -114vh, 0)
            transform: translate3d(49vw, -114vh, 0)
  

.circle-container:nth-child(36) .circle 
  -webkit-animation-delay: 1659ms
          animation-delay: 1659ms

.circle-container:nth-child(37) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-37
          animation-name: move-frames-37
  -webkit-animation-duration: 28679ms
          animation-duration: 28679ms
  -webkit-animation-delay: 11272ms
          animation-delay: 11272ms

@-webkit-keyframes move-frames-37 
  from 
    -webkit-transform: translate3d(3vw, 102vh, 0)
            transform: translate3d(3vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(5vw, -122vh, 0)
            transform: translate3d(5vw, -122vh, 0)
  

@keyframes move-frames-37 
  from 
    -webkit-transform: translate3d(3vw, 102vh, 0)
            transform: translate3d(3vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(5vw, -122vh, 0)
            transform: translate3d(5vw, -122vh, 0)
  

.circle-container:nth-child(37) .circle 
  -webkit-animation-delay: 1872ms
          animation-delay: 1872ms

.circle-container:nth-child(38) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-38
          animation-name: move-frames-38
  -webkit-animation-duration: 33170ms
          animation-duration: 33170ms
  -webkit-animation-delay: 36129ms
          animation-delay: 36129ms

@-webkit-keyframes move-frames-38 
  from 
    -webkit-transform: translate3d(40vw, 101vh, 0)
            transform: translate3d(40vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(65vw, -113vh, 0)
            transform: translate3d(65vw, -113vh, 0)
  

@keyframes move-frames-38 
  from 
    -webkit-transform: translate3d(40vw, 101vh, 0)
            transform: translate3d(40vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(65vw, -113vh, 0)
            transform: translate3d(65vw, -113vh, 0)
  

.circle-container:nth-child(38) .circle 
  -webkit-animation-delay: 2034ms
          animation-delay: 2034ms

.circle-container:nth-child(39) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-39
          animation-name: move-frames-39
  -webkit-animation-duration: 32383ms
          animation-duration: 32383ms
  -webkit-animation-delay: 12852ms
          animation-delay: 12852ms

@-webkit-keyframes move-frames-39 
  from 
    -webkit-transform: translate3d(45vw, 101vh, 0)
            transform: translate3d(45vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(55vw, -126vh, 0)
            transform: translate3d(55vw, -126vh, 0)
  

@keyframes move-frames-39 
  from 
    -webkit-transform: translate3d(45vw, 101vh, 0)
            transform: translate3d(45vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(55vw, -126vh, 0)
            transform: translate3d(55vw, -126vh, 0)
  

.circle-container:nth-child(39) .circle 
  -webkit-animation-delay: 710ms
          animation-delay: 710ms

.circle-container:nth-child(40) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-40
          animation-name: move-frames-40
  -webkit-animation-duration: 36807ms
          animation-duration: 36807ms
  -webkit-animation-delay: 7650ms
          animation-delay: 7650ms

@-webkit-keyframes move-frames-40 
  from 
    -webkit-transform: translate3d(42vw, 108vh, 0)
            transform: translate3d(42vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(93vw, -124vh, 0)
            transform: translate3d(93vw, -124vh, 0)
  

@keyframes move-frames-40 
  from 
    -webkit-transform: translate3d(42vw, 108vh, 0)
            transform: translate3d(42vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(93vw, -124vh, 0)
            transform: translate3d(93vw, -124vh, 0)
  

.circle-container:nth-child(40) .circle 
  -webkit-animation-delay: 459ms
          animation-delay: 459ms

.circle-container:nth-child(41) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-41
          animation-name: move-frames-41
  -webkit-animation-duration: 34570ms
          animation-duration: 34570ms
  -webkit-animation-delay: 35125ms
          animation-delay: 35125ms

@-webkit-keyframes move-frames-41 
  from 
    -webkit-transform: translate3d(96vw, 102vh, 0)
            transform: translate3d(96vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(26vw, -128vh, 0)
            transform: translate3d(26vw, -128vh, 0)
  

@keyframes move-frames-41 
  from 
    -webkit-transform: translate3d(96vw, 102vh, 0)
            transform: translate3d(96vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(26vw, -128vh, 0)
            transform: translate3d(26vw, -128vh, 0)
  

.circle-container:nth-child(41) .circle 
  -webkit-animation-delay: 3205ms
          animation-delay: 3205ms

.circle-container:nth-child(42) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-42
          animation-name: move-frames-42
  -webkit-animation-duration: 31428ms
          animation-duration: 31428ms
  -webkit-animation-delay: 24853ms
          animation-delay: 24853ms

@-webkit-keyframes move-frames-42 
  from 
    -webkit-transform: translate3d(25vw, 102vh, 0)
            transform: translate3d(25vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(67vw, -108vh, 0)
            transform: translate3d(67vw, -108vh, 0)
  

@keyframes move-frames-42 
  from 
    -webkit-transform: translate3d(25vw, 102vh, 0)
            transform: translate3d(25vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(67vw, -108vh, 0)
            transform: translate3d(67vw, -108vh, 0)
  

.circle-container:nth-child(42) .circle 
  -webkit-animation-delay: 3428ms
          animation-delay: 3428ms

.circle-container:nth-child(43) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-43
          animation-name: move-frames-43
  -webkit-animation-duration: 29719ms
          animation-duration: 29719ms
  -webkit-animation-delay: 9547ms
          animation-delay: 9547ms

@-webkit-keyframes move-frames-43 
  from 
    -webkit-transform: translate3d(58vw, 107vh, 0)
            transform: translate3d(58vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(88vw, -131vh, 0)
            transform: translate3d(88vw, -131vh, 0)
  

@keyframes move-frames-43 
  from 
    -webkit-transform: translate3d(58vw, 107vh, 0)
            transform: translate3d(58vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(88vw, -131vh, 0)
            transform: translate3d(88vw, -131vh, 0)
  

.circle-container:nth-child(43) .circle 
  -webkit-animation-delay: 1600ms
          animation-delay: 1600ms

.circle-container:nth-child(44) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-44
          animation-name: move-frames-44
  -webkit-animation-duration: 30605ms
          animation-duration: 30605ms
  -webkit-animation-delay: 21395ms
          animation-delay: 21395ms

@-webkit-keyframes move-frames-44 
  from 
    -webkit-transform: translate3d(96vw, 106vh, 0)
            transform: translate3d(96vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -112vh, 0)
            transform: translate3d(16vw, -112vh, 0)
  

@keyframes move-frames-44 
  from 
    -webkit-transform: translate3d(96vw, 106vh, 0)
            transform: translate3d(96vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -112vh, 0)
            transform: translate3d(16vw, -112vh, 0)
  

.circle-container:nth-child(44) .circle 
  -webkit-animation-delay: 3918ms
          animation-delay: 3918ms

.circle-container:nth-child(45) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-45
          animation-name: move-frames-45
  -webkit-animation-duration: 36914ms
          animation-duration: 36914ms
  -webkit-animation-delay: 13268ms
          animation-delay: 13268ms

@-webkit-keyframes move-frames-45 
  from 
    -webkit-transform: translate3d(62vw, 104vh, 0)
            transform: translate3d(62vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -117vh, 0)
            transform: translate3d(41vw, -117vh, 0)
  

@keyframes move-frames-45 
  from 
    -webkit-transform: translate3d(62vw, 104vh, 0)
            transform: translate3d(62vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -117vh, 0)
            transform: translate3d(41vw, -117vh, 0)
  

.circle-container:nth-child(45) .circle 
  -webkit-animation-delay: 1167ms
          animation-delay: 1167ms

.circle-container:nth-child(46) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-46
          animation-name: move-frames-46
  -webkit-animation-duration: 36798ms
          animation-duration: 36798ms
  -webkit-animation-delay: 1119ms
          animation-delay: 1119ms

@-webkit-keyframes move-frames-46 
  from 
    -webkit-transform: translate3d(9vw, 103vh, 0)
            transform: translate3d(9vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -107vh, 0)
            transform: translate3d(47vw, -107vh, 0)
  

@keyframes move-frames-46 
  from 
    -webkit-transform: translate3d(9vw, 103vh, 0)
            transform: translate3d(9vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -107vh, 0)
            transform: translate3d(47vw, -107vh, 0)
  

.circle-container:nth-child(46) .circle 
  -webkit-animation-delay: 968ms
          animation-delay: 968ms

.circle-container:nth-child(47) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-47
          animation-name: move-frames-47
  -webkit-animation-duration: 33653ms
          animation-duration: 33653ms
  -webkit-animation-delay: 18314ms
          animation-delay: 18314ms

@-webkit-keyframes move-frames-47 
  from 
    -webkit-transform: translate3d(83vw, 110vh, 0)
            transform: translate3d(83vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(98vw, -113vh, 0)
            transform: translate3d(98vw, -113vh, 0)
  

@keyframes move-frames-47 
  from 
    -webkit-transform: translate3d(83vw, 110vh, 0)
            transform: translate3d(83vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(98vw, -113vh, 0)
            transform: translate3d(98vw, -113vh, 0)
  

.circle-container:nth-child(47) .circle 
  -webkit-animation-delay: 3988ms
          animation-delay: 3988ms

.circle-container:nth-child(48) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-48
          animation-name: move-frames-48
  -webkit-animation-duration: 29667ms
          animation-duration: 29667ms
  -webkit-animation-delay: 7239ms
          animation-delay: 7239ms

@-webkit-keyframes move-frames-48 
  from 
    -webkit-transform: translate3d(55vw, 102vh, 0)
            transform: translate3d(55vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(40vw, -112vh, 0)
            transform: translate3d(40vw, -112vh, 0)
  

@keyframes move-frames-48 
  from 
    -webkit-transform: translate3d(55vw, 102vh, 0)
            transform: translate3d(55vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(40vw, -112vh, 0)
            transform: translate3d(40vw, -112vh, 0)
  

.circle-container:nth-child(48) .circle 
  -webkit-animation-delay: 2746ms
          animation-delay: 2746ms

.circle-container:nth-child(49) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-49
          animation-name: move-frames-49
  -webkit-animation-duration: 29225ms
          animation-duration: 29225ms
  -webkit-animation-delay: 1566ms
          animation-delay: 1566ms

@-webkit-keyframes move-frames-49 
  from 
    -webkit-transform: translate3d(62vw, 105vh, 0)
            transform: translate3d(62vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(48vw, -134vh, 0)
            transform: translate3d(48vw, -134vh, 0)
  

@keyframes move-frames-49 
  from 
    -webkit-transform: translate3d(62vw, 105vh, 0)
            transform: translate3d(62vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(48vw, -134vh, 0)
            transform: translate3d(48vw, -134vh, 0)
  

.circle-container:nth-child(49) .circle 
  -webkit-animation-delay: 71ms
          animation-delay: 71ms

.circle-container:nth-child(50) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-50
          animation-name: move-frames-50
  -webkit-animation-duration: 35531ms
          animation-duration: 35531ms
  -webkit-animation-delay: 3663ms
          animation-delay: 3663ms

@-webkit-keyframes move-frames-50 
  from 
    -webkit-transform: translate3d(35vw, 106vh, 0)
            transform: translate3d(35vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(73vw, -129vh, 0)
            transform: translate3d(73vw, -129vh, 0)
  

@keyframes move-frames-50 
  from 
    -webkit-transform: translate3d(35vw, 106vh, 0)
            transform: translate3d(35vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(73vw, -129vh, 0)
            transform: translate3d(73vw, -129vh, 0)
  

.circle-container:nth-child(50) .circle 
  -webkit-animation-delay: 134ms
          animation-delay: 134ms

.circle-container:nth-child(51) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-51
          animation-name: move-frames-51
  -webkit-animation-duration: 33573ms
          animation-duration: 33573ms
  -webkit-animation-delay: 11807ms
          animation-delay: 11807ms

@-webkit-keyframes move-frames-51 
  from 
    -webkit-transform: translate3d(42vw, 107vh, 0)
            transform: translate3d(42vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -125vh, 0)
            transform: translate3d(16vw, -125vh, 0)
  

@keyframes move-frames-51 
  from 
    -webkit-transform: translate3d(42vw, 107vh, 0)
            transform: translate3d(42vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -125vh, 0)
            transform: translate3d(16vw, -125vh, 0)
  

.circle-container:nth-child(51) .circle 
  -webkit-animation-delay: 547ms
          animation-delay: 547ms

.circle-container:nth-child(52) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-52
          animation-name: move-frames-52
  -webkit-animation-duration: 36694ms
          animation-duration: 36694ms
  -webkit-animation-delay: 23819ms
          animation-delay: 23819ms

@-webkit-keyframes move-frames-52 
  from 
    -webkit-transform: translate3d(35vw, 102vh, 0)
            transform: translate3d(35vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(90vw, -107vh, 0)
            transform: translate3d(90vw, -107vh, 0)
  

@keyframes move-frames-52 
  from 
    -webkit-transform: translate3d(35vw, 102vh, 0)
            transform: translate3d(35vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(90vw, -107vh, 0)
            transform: translate3d(90vw, -107vh, 0)
  

.circle-container:nth-child(52) .circle 
  -webkit-animation-delay: 1363ms
          animation-delay: 1363ms

.circle-container:nth-child(53) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-53
          animation-name: move-frames-53
  -webkit-animation-duration: 36407ms
          animation-duration: 36407ms
  -webkit-animation-delay: 16269ms
          animation-delay: 16269ms

@-webkit-keyframes move-frames-53 
  from 
    -webkit-transform: translate3d(57vw, 102vh, 0)
            transform: translate3d(57vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(12vw, -117vh, 0)
            transform: translate3d(12vw, -117vh, 0)
  

@keyframes move-frames-53 
  from 
    -webkit-transform: translate3d(57vw, 102vh, 0)
            transform: translate3d(57vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(12vw, -117vh, 0)
            transform: translate3d(12vw, -117vh, 0)
  

.circle-container:nth-child(53) .circle 
  -webkit-animation-delay: 1533ms
          animation-delay: 1533ms

.circle-container:nth-child(54) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-54
          animation-name: move-frames-54
  -webkit-animation-duration: 28720ms
          animation-duration: 28720ms
  -webkit-animation-delay: 17800ms
          animation-delay: 17800ms

@-webkit-keyframes move-frames-54 
  from 
    -webkit-transform: translate3d(6vw, 109vh, 0)
            transform: translate3d(6vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(2vw, -111vh, 0)
            transform: translate3d(2vw, -111vh, 0)
  

@keyframes move-frames-54 
  from 
    -webkit-transform: translate3d(6vw, 109vh, 0)
            transform: translate3d(6vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(2vw, -111vh, 0)
            transform: translate3d(2vw, -111vh, 0)
  

.circle-container:nth-child(54) .circle 
  -webkit-animation-delay: 1903ms
          animation-delay: 1903ms

.circle-container:nth-child(55) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-55
          animation-name: move-frames-55
  -webkit-animation-duration: 30211ms
          animation-duration: 30211ms
  -webkit-animation-delay: 14858ms
          animation-delay: 14858ms

@-webkit-keyframes move-frames-55 
  from 
    -webkit-transform: translate3d(95vw, 110vh, 0)
            transform: translate3d(95vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -120vh, 0)
            transform: translate3d(34vw, -120vh, 0)
  

@keyframes move-frames-55 
  from 
    -webkit-transform: translate3d(95vw, 110vh, 0)
            transform: translate3d(95vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -120vh, 0)
            transform: translate3d(34vw, -120vh, 0)
  

.circle-container:nth-child(55) .circle 
  -webkit-animation-delay: 2104ms
          animation-delay: 2104ms

.circle-container:nth-child(56) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-56
          animation-name: move-frames-56
  -webkit-animation-duration: 36297ms
          animation-duration: 36297ms
  -webkit-animation-delay: 15556ms
          animation-delay: 15556ms

@-webkit-keyframes move-frames-56 
  from 
    -webkit-transform: translate3d(59vw, 105vh, 0)
            transform: translate3d(59vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(97vw, -130vh, 0)
            transform: translate3d(97vw, -130vh, 0)
  

@keyframes move-frames-56 
  from 
    -webkit-transform: translate3d(59vw, 105vh, 0)
            transform: translate3d(59vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(97vw, -130vh, 0)
            transform: translate3d(97vw, -130vh, 0)
  

.circle-container:nth-child(56) .circle 
  -webkit-animation-delay: 1746ms
          animation-delay: 1746ms

.circle-container:nth-child(57) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-57
          animation-name: move-frames-57
  -webkit-animation-duration: 31703ms
          animation-duration: 31703ms
  -webkit-animation-delay: 12ms
          animation-delay: 12ms

@-webkit-keyframes move-frames-57 
  from 
    -webkit-transform: translate3d(11vw, 109vh, 0)
            transform: translate3d(11vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(4vw, -116vh, 0)
            transform: translate3d(4vw, -116vh, 0)
  

@keyframes move-frames-57 
  from 
    -webkit-transform: translate3d(11vw, 109vh, 0)
            transform: translate3d(11vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(4vw, -116vh, 0)
            transform: translate3d(4vw, -116vh, 0)
  

.circle-container:nth-child(57) .circle 
  -webkit-animation-delay: 527ms
          animation-delay: 527ms

.circle-container:nth-child(58) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-58
          animation-name: move-frames-58
  -webkit-animation-duration: 36240ms
          animation-duration: 36240ms
  -webkit-animation-delay: 5124ms
          animation-delay: 5124ms

@-webkit-keyframes move-frames-58 
  from 
    -webkit-transform: translate3d(62vw, 104vh, 0)
            transform: translate3d(62vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(21vw, -125vh, 0)
            transform: translate3d(21vw, -125vh, 0)
  

@keyframes move-frames-58 
  from 
    -webkit-transform: translate3d(62vw, 104vh, 0)
            transform: translate3d(62vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(21vw, -125vh, 0)
            transform: translate3d(21vw, -125vh, 0)
  

.circle-container:nth-child(58) .circle 
  -webkit-animation-delay: 1778ms
          animation-delay: 1778ms

.circle-container:nth-child(59) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-59
          animation-name: move-frames-59
  -webkit-animation-duration: 30622ms
          animation-duration: 30622ms
  -webkit-animation-delay: 26262ms
          animation-delay: 26262ms

@-webkit-keyframes move-frames-59 
  from 
    -webkit-transform: translate3d(38vw, 104vh, 0)
            transform: translate3d(38vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(25vw, -129vh, 0)
            transform: translate3d(25vw, -129vh, 0)
  

@keyframes move-frames-59 
  from 
    -webkit-transform: translate3d(38vw, 104vh, 0)
            transform: translate3d(38vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(25vw, -129vh, 0)
            transform: translate3d(25vw, -129vh, 0)
  

.circle-container:nth-child(59) .circle 
  -webkit-animation-delay: 3699ms
          animation-delay: 3699ms

.circle-container:nth-child(60) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-60
          animation-name: move-frames-60
  -webkit-animation-duration: 35898ms
          animation-duration: 35898ms
  -webkit-animation-delay: 5248ms
          animation-delay: 5248ms

@-webkit-keyframes move-frames-60 
  from 
    -webkit-transform: translate3d(51vw, 109vh, 0)
            transform: translate3d(51vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(62vw, -119vh, 0)
            transform: translate3d(62vw, -119vh, 0)
  

@keyframes move-frames-60 
  from 
    -webkit-transform: translate3d(51vw, 109vh, 0)
            transform: translate3d(51vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(62vw, -119vh, 0)
            transform: translate3d(62vw, -119vh, 0)
  

.circle-container:nth-child(60) .circle 
  -webkit-animation-delay: 562ms
          animation-delay: 562ms

.circle-container:nth-child(61) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-61
          animation-name: move-frames-61
  -webkit-animation-duration: 28302ms
          animation-duration: 28302ms
  -webkit-animation-delay: 4624ms
          animation-delay: 4624ms

@-webkit-keyframes move-frames-61 
  from 
    -webkit-transform: translate3d(25vw, 110vh, 0)
            transform: translate3d(25vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -138vh, 0)
            transform: translate3d(87vw, -138vh, 0)
  

@keyframes move-frames-61 
  from 
    -webkit-transform: translate3d(25vw, 110vh, 0)
            transform: translate3d(25vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -138vh, 0)
            transform: translate3d(87vw, -138vh, 0)
  

.circle-container:nth-child(61) .circle 
  -webkit-animation-delay: 3027ms
          animation-delay: 3027ms

.circle-container:nth-child(62) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-62
          animation-name: move-frames-62
  -webkit-animation-duration: 30400ms
          animation-duration: 30400ms
  -webkit-animation-delay: 17655ms
          animation-delay: 17655ms

@-webkit-keyframes move-frames-62 
  from 
    -webkit-transform: translate3d(83vw, 107vh, 0)
            transform: translate3d(83vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(46vw, -122vh, 0)
            transform: translate3d(46vw, -122vh, 0)
  

@keyframes move-frames-62 
  from 
    -webkit-transform: translate3d(83vw, 107vh, 0)
            transform: translate3d(83vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(46vw, -122vh, 0)
            transform: translate3d(46vw, -122vh, 0)
  

.circle-container:nth-child(62) .circle 
  -webkit-animation-delay: 1984ms
          animation-delay: 1984ms

.circle-container:nth-child(63) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-63
          animation-name: move-frames-63
  -webkit-animation-duration: 32137ms
          animation-duration: 32137ms
  -webkit-animation-delay: 30436ms
          animation-delay: 30436ms

@-webkit-keyframes move-frames-63 
  from 
    -webkit-transform: translate3d(97vw, 110vh, 0)
            transform: translate3d(97vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -121vh, 0)
            transform: translate3d(30vw, -121vh, 0)
  

@keyframes move-frames-63 
  from 
    -webkit-transform: translate3d(97vw, 110vh, 0)
            transform: translate3d(97vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -121vh, 0)
            transform: translate3d(30vw, -121vh, 0)
  

.circle-container:nth-child(63) .circle 
  -webkit-animation-delay: 3403ms
          animation-delay: 3403ms

.circle-container:nth-child(64) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-64
          animation-name: move-frames-64
  -webkit-animation-duration: 31419ms
          animation-duration: 31419ms
  -webkit-animation-delay: 20043ms
          animation-delay: 20043ms

@-webkit-keyframes move-frames-64 
  from 
    -webkit-transform: translate3d(24vw, 102vh, 0)
            transform: translate3d(24vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -117vh, 0)
            transform: translate3d(95vw, -117vh, 0)
  

@keyframes move-frames-64 
  from 
    -webkit-transform: translate3d(24vw, 102vh, 0)
            transform: translate3d(24vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -117vh, 0)
            transform: translate3d(95vw, -117vh, 0)
  

.circle-container:nth-child(64) .circle 
  -webkit-animation-delay: 2595ms
          animation-delay: 2595ms

.circle-container:nth-child(65) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-65
          animation-name: move-frames-65
  -webkit-animation-duration: 29483ms
          animation-duration: 29483ms
  -webkit-animation-delay: 9788ms
          animation-delay: 9788ms

@-webkit-keyframes move-frames-65 
  from 
    -webkit-transform: translate3d(47vw, 104vh, 0)
            transform: translate3d(47vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(22vw, -131vh, 0)
            transform: translate3d(22vw, -131vh, 0)
  

@keyframes move-frames-65 
  from 
    -webkit-transform: translate3d(47vw, 104vh, 0)
            transform: translate3d(47vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(22vw, -131vh, 0)
            transform: translate3d(22vw, -131vh, 0)
  

.circle-container:nth-child(65) .circle 
  -webkit-animation-delay: 6ms
          animation-delay: 6ms

.circle-container:nth-child(66) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-66
          animation-name: move-frames-66
  -webkit-animation-duration: 31370ms
          animation-duration: 31370ms
  -webkit-animation-delay: 26064ms
          animation-delay: 26064ms

@-webkit-keyframes move-frames-66 
  from 
    -webkit-transform: translate3d(70vw, 101vh, 0)
            transform: translate3d(70vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -105vh, 0)
            transform: translate3d(87vw, -105vh, 0)
  

@keyframes move-frames-66 
  from 
    -webkit-transform: translate3d(70vw, 101vh, 0)
            transform: translate3d(70vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -105vh, 0)
            transform: translate3d(87vw, -105vh, 0)
  

.circle-container:nth-child(66) .circle 
  -webkit-animation-delay: 2311ms
          animation-delay: 2311ms

.circle-container:nth-child(67) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-67
          animation-name: move-frames-67
  -webkit-animation-duration: 29878ms
          animation-duration: 29878ms
  -webkit-animation-delay: 11458ms
          animation-delay: 11458ms

@-webkit-keyframes move-frames-67 
  from 
    -webkit-transform: translate3d(81vw, 109vh, 0)
            transform: translate3d(81vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(26vw, -110vh, 0)
            transform: translate3d(26vw, -110vh, 0)
  

@keyframes move-frames-67 
  from 
    -webkit-transform: translate3d(81vw, 109vh, 0)
            transform: translate3d(81vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(26vw, -110vh, 0)
            transform: translate3d(26vw, -110vh, 0)
  

.circle-container:nth-child(67) .circle 
  -webkit-animation-delay: 1072ms
          animation-delay: 1072ms

.circle-container:nth-child(68) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-68
          animation-name: move-frames-68
  -webkit-animation-duration: 32412ms
          animation-duration: 32412ms
  -webkit-animation-delay: 30363ms
          animation-delay: 30363ms

@-webkit-keyframes move-frames-68 
  from 
    -webkit-transform: translate3d(36vw, 103vh, 0)
            transform: translate3d(36vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -122vh, 0)
            transform: translate3d(27vw, -122vh, 0)
  

@keyframes move-frames-68 
  from 
    -webkit-transform: translate3d(36vw, 103vh, 0)
            transform: translate3d(36vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -122vh, 0)
            transform: translate3d(27vw, -122vh, 0)
  

.circle-container:nth-child(68) .circle 
  -webkit-animation-delay: 3212ms
          animation-delay: 3212ms

.circle-container:nth-child(69) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-69
          animation-name: move-frames-69
  -webkit-animation-duration: 35373ms
          animation-duration: 35373ms
  -webkit-animation-delay: 32852ms
          animation-delay: 32852ms

@-webkit-keyframes move-frames-69 
  from 
    -webkit-transform: translate3d(9vw, 108vh, 0)
            transform: translate3d(9vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -121vh, 0)
            transform: translate3d(68vw, -121vh, 0)
  

@keyframes move-frames-69 
  from 
    -webkit-transform: translate3d(9vw, 108vh, 0)
            transform: translate3d(9vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -121vh, 0)
            transform: translate3d(68vw, -121vh, 0)
  

.circle-container:nth-child(69) .circle 
  -webkit-animation-delay: 2847ms
          animation-delay: 2847ms

.circle-container:nth-child(70) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-70
          animation-name: move-frames-70
  -webkit-animation-duration: 31004ms
          animation-duration: 31004ms
  -webkit-animation-delay: 6066ms
          animation-delay: 6066ms

@-webkit-keyframes move-frames-70 
  from 
    -webkit-transform: translate3d(44vw, 110vh, 0)
            transform: translate3d(44vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -116vh, 0)
            transform: translate3d(41vw, -116vh, 0)
  

@keyframes move-frames-70 
  from 
    -webkit-transform: translate3d(44vw, 110vh, 0)
            transform: translate3d(44vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -116vh, 0)
            transform: translate3d(41vw, -116vh, 0)
  

.circle-container:nth-child(70) .circle 
  -webkit-animation-delay: 3412ms
          animation-delay: 3412ms

.circle-container:nth-child(71) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-71
          animation-name: move-frames-71
  -webkit-animation-duration: 29439ms
          animation-duration: 29439ms
  -webkit-animation-delay: 18936ms
          animation-delay: 18936ms

@-webkit-keyframes move-frames-71 
  from 
    -webkit-transform: translate3d(89vw, 102vh, 0)
            transform: translate3d(89vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(81vw, -127vh, 0)
            transform: translate3d(81vw, -127vh, 0)
  

@keyframes move-frames-71 
  from 
    -webkit-transform: translate3d(89vw, 102vh, 0)
            transform: translate3d(89vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(81vw, -127vh, 0)
            transform: translate3d(81vw, -127vh, 0)
  

.circle-container:nth-child(71) .circle 
  -webkit-animation-delay: 391ms
          animation-delay: 391ms

.circle-container:nth-child(72) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-72
          animation-name: move-frames-72
  -webkit-animation-duration: 34318ms
          animation-duration: 34318ms
  -webkit-animation-delay: 8687ms
          animation-delay: 8687ms

@-webkit-keyframes move-frames-72 
  from 
    -webkit-transform: translate3d(58vw, 109vh, 0)
            transform: translate3d(58vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(17vw, -119vh, 0)
            transform: translate3d(17vw, -119vh, 0)
  

@keyframes move-frames-72 
  from 
    -webkit-transform: translate3d(58vw, 109vh, 0)
            transform: translate3d(58vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(17vw, -119vh, 0)
            transform: translate3d(17vw, -119vh, 0)
  

.circle-container:nth-child(72) .circle 
  -webkit-animation-delay: 2082ms
          animation-delay: 2082ms

.circle-container:nth-child(73) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-73
          animation-name: move-frames-73
  -webkit-animation-duration: 34056ms
          animation-duration: 34056ms
  -webkit-animation-delay: 29022ms
          animation-delay: 29022ms

@-webkit-keyframes move-frames-73 
  from 
    -webkit-transform: translate3d(72vw, 109vh, 0)
            transform: translate3d(72vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(28vw, -113vh, 0)
            transform: translate3d(28vw, -113vh, 0)
  

@keyframes move-frames-73 
  from 
    -webkit-transform: translate3d(72vw, 109vh, 0)
            transform: translate3d(72vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(28vw, -113vh, 0)
            transform: translate3d(28vw, -113vh, 0)
  

.circle-container:nth-child(73) .circle 
  -webkit-animation-delay: 1105ms
          animation-delay: 1105ms

.circle-container:nth-child(74) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-74
          animation-name: move-frames-74
  -webkit-animation-duration: 29818ms
          animation-duration: 29818ms
  -webkit-animation-delay: 19782ms
          animation-delay: 19782ms

@-webkit-keyframes move-frames-74 
  from 
    -webkit-transform: translate3d(51vw, 110vh, 0)
            transform: translate3d(51vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(38vw, -119vh, 0)
            transform: translate3d(38vw, -119vh, 0)
  

@keyframes move-frames-74 
  from 
    -webkit-transform: translate3d(51vw, 110vh, 0)
            transform: translate3d(51vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(38vw, -119vh, 0)
            transform: translate3d(38vw, -119vh, 0)
  

.circle-container:nth-child(74) .circle 
  -webkit-animation-delay: 3544ms
          animation-delay: 3544ms

.circle-container:nth-child(75) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-75
          animation-name: move-frames-75
  -webkit-animation-duration: 32961ms
          animation-duration: 32961ms
  -webkit-animation-delay: 34368ms
          animation-delay: 34368ms

@-webkit-keyframes move-frames-75 
  from 
    -webkit-transform: translate3d(24vw, 109vh, 0)
            transform: translate3d(24vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -110vh, 0)
            transform: translate3d(76vw, -110vh, 0)
  

@keyframes move-frames-75 
  from 
    -webkit-transform: translate3d(24vw, 109vh, 0)
            transform: translate3d(24vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -110vh, 0)
            transform: translate3d(76vw, -110vh, 0)
  

.circle-container:nth-child(75) .circle 
  -webkit-animation-delay: 1337ms
          animation-delay: 1337ms

.circle-container:nth-child(76) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-76
          animation-name: move-frames-76
  -webkit-animation-duration: 29295ms
          animation-duration: 29295ms
  -webkit-animation-delay: 2855ms
          animation-delay: 2855ms

@-webkit-keyframes move-frames-76 
  from 
    -webkit-transform: translate3d(46vw, 101vh, 0)
            transform: translate3d(46vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(28vw, -102vh, 0)
            transform: translate3d(28vw, -102vh, 0)
  

@keyframes move-frames-76 
  from 
    -webkit-transform: translate3d(46vw, 101vh, 0)
            transform: translate3d(46vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(28vw, -102vh, 0)
            transform: translate3d(28vw, -102vh, 0)
  

.circle-container:nth-child(76) .circle 
  -webkit-animation-delay: 1601ms
          animation-delay: 1601ms

.circle-container:nth-child(77) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-77
          animation-name: move-frames-77
  -webkit-animation-duration: 34991ms
          animation-duration: 34991ms
  -webkit-animation-delay: 1743ms
          animation-delay: 1743ms

@-webkit-keyframes move-frames-77 
  from 
    -webkit-transform: translate3d(80vw, 107vh, 0)
            transform: translate3d(80vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -130vh, 0)
            transform: translate3d(31vw, -130vh, 0)
  

@keyframes move-frames-77 
  from 
    -webkit-transform: translate3d(80vw, 107vh, 0)
            transform: translate3d(80vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -130vh, 0)
            transform: translate3d(31vw, -130vh, 0)
  

.circle-container:nth-child(77) .circle 
  -webkit-animation-delay: 1663ms
          animation-delay: 1663ms

.circle-container:nth-child(78) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-78
          animation-name: move-frames-78
  -webkit-animation-duration: 32986ms
          animation-duration: 32986ms
  -webkit-animation-delay: 8894ms
          animation-delay: 8894ms

@-webkit-keyframes move-frames-78 
  from 
    -webkit-transform: translate3d(55vw, 107vh, 0)
            transform: translate3d(55vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(38vw, -115vh, 0)
            transform: translate3d(38vw, -115vh, 0)
  

@keyframes move-frames-78 
  from 
    -webkit-transform: translate3d(55vw, 107vh, 0)
            transform: translate3d(55vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(38vw, -115vh, 0)
            transform: translate3d(38vw, -115vh, 0)
  

.circle-container:nth-child(78) .circle 
  -webkit-animation-delay: 2193ms
          animation-delay: 2193ms

.circle-container:nth-child(79) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-79
          animation-name: move-frames-79
  -webkit-animation-duration: 31915ms
          animation-duration: 31915ms
  -webkit-animation-delay: 10350ms
          animation-delay: 10350ms

@-webkit-keyframes move-frames-79 
  from 
    -webkit-transform: translate3d(98vw, 109vh, 0)
            transform: translate3d(98vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -119vh, 0)
            transform: translate3d(47vw, -119vh, 0)
  

@keyframes move-frames-79 
  from 
    -webkit-transform: translate3d(98vw, 109vh, 0)
            transform: translate3d(98vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -119vh, 0)
            transform: translate3d(47vw, -119vh, 0)
  

.circle-container:nth-child(79) .circle 
  -webkit-animation-delay: 2273ms
          animation-delay: 2273ms

.circle-container:nth-child(80) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-80
          animation-name: move-frames-80
  -webkit-animation-duration: 32368ms
          animation-duration: 32368ms
  -webkit-animation-delay: 24668ms
          animation-delay: 24668ms

@-webkit-keyframes move-frames-80 
  from 
    -webkit-transform: translate3d(97vw, 110vh, 0)
            transform: translate3d(97vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(9vw, -135vh, 0)
            transform: translate3d(9vw, -135vh, 0)
  

@keyframes move-frames-80 
  from 
    -webkit-transform: translate3d(97vw, 110vh, 0)
            transform: translate3d(97vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(9vw, -135vh, 0)
            transform: translate3d(9vw, -135vh, 0)
  

.circle-container:nth-child(80) .circle 
  -webkit-animation-delay: 686ms
          animation-delay: 686ms

.circle-container:nth-child(81) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-81
          animation-name: move-frames-81
  -webkit-animation-duration: 34007ms
          animation-duration: 34007ms
  -webkit-animation-delay: 23002ms
          animation-delay: 23002ms

@-webkit-keyframes move-frames-81 
  from 
    -webkit-transform: translate3d(51vw, 106vh, 0)
            transform: translate3d(51vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(59vw, -128vh, 0)
            transform: translate3d(59vw, -128vh, 0)
  

@keyframes move-frames-81 
  from 
    -webkit-transform: translate3d(51vw, 106vh, 0)
            transform: translate3d(51vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(59vw, -128vh, 0)
            transform: translate3d(59vw, -128vh, 0)
  

.circle-container:nth-child(81) .circle 
  -webkit-animation-delay: 3166ms
          animation-delay: 3166ms

.circle-container:nth-child(82) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-82
          animation-name: move-frames-82
  -webkit-animation-duration: 36481ms
          animation-duration: 36481ms
  -webkit-animation-delay: 25269ms
          animation-delay: 25269ms

@-webkit-keyframes move-frames-82 
  from 
    -webkit-transform: translate3d(50vw, 103vh, 0)
            transform: translate3d(50vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(51vw, -131vh, 0)
            transform: translate3d(51vw, -131vh, 0)
  

@keyframes move-frames-82 
  from 
    -webkit-transform: translate3d(50vw, 103vh, 0)
            transform: translate3d(50vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(51vw, -131vh, 0)
            transform: translate3d(51vw, -131vh, 0)
  

.circle-container:nth-child(82) .circle 
  -webkit-animation-delay: 3447ms
          animation-delay: 3447ms

.circle-container:nth-child(83) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-83
          animation-name: move-frames-83
  -webkit-animation-duration: 36454ms
          animation-duration: 36454ms
  -webkit-animation-delay: 26211ms
          animation-delay: 26211ms

@-webkit-keyframes move-frames-83 
  from 
    -webkit-transform: translate3d(44vw, 107vh, 0)
            transform: translate3d(44vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -129vh, 0)
            transform: translate3d(95vw, -129vh, 0)
  

@keyframes move-frames-83 
  from 
    -webkit-transform: translate3d(44vw, 107vh, 0)
            transform: translate3d(44vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -129vh, 0)
            transform: translate3d(95vw, -129vh, 0)
  

.circle-container:nth-child(83) .circle 
  -webkit-animation-delay: 108ms
          animation-delay: 108ms

.circle-container:nth-child(84) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-84
          animation-name: move-frames-84
  -webkit-animation-duration: 30665ms
          animation-duration: 30665ms
  -webkit-animation-delay: 27709ms
          animation-delay: 27709ms

@-webkit-keyframes move-frames-84 
  from 
    -webkit-transform: translate3d(66vw, 108vh, 0)
            transform: translate3d(66vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(83vw, -128vh, 0)
            transform: translate3d(83vw, -128vh, 0)
  

@keyframes move-frames-84 
  from 
    -webkit-transform: translate3d(66vw, 108vh, 0)
            transform: translate3d(66vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(83vw, -128vh, 0)
            transform: translate3d(83vw, -128vh, 0)
  

.circle-container:nth-child(84) .circle 
  -webkit-animation-delay: 1816ms
          animation-delay: 1816ms

.circle-container:nth-child(85) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-85
          animation-name: move-frames-85
  -webkit-animation-duration: 31266ms
          animation-duration: 31266ms
  -webkit-animation-delay: 24900ms
          animation-delay: 24900ms

@-webkit-keyframes move-frames-85 
  from 
    -webkit-transform: translate3d(2vw, 102vh, 0)
            transform: translate3d(2vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -130vh, 0)
            transform: translate3d(27vw, -130vh, 0)
  

@keyframes move-frames-85 
  from 
    -webkit-transform: translate3d(2vw, 102vh, 0)
            transform: translate3d(2vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -130vh, 0)
            transform: translate3d(27vw, -130vh, 0)
  

.circle-container:nth-child(85) .circle 
  -webkit-animation-delay: 3589ms
          animation-delay: 3589ms

.circle-container:nth-child(86) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-86
          animation-name: move-frames-86
  -webkit-animation-duration: 29420ms
          animation-duration: 29420ms
  -webkit-animation-delay: 25152ms
          animation-delay: 25152ms

@-webkit-keyframes move-frames-86 
  from 
    -webkit-transform: translate3d(82vw, 107vh, 0)
            transform: translate3d(82vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(90vw, -135vh, 0)
            transform: translate3d(90vw, -135vh, 0)
  

@keyframes move-frames-86 
  from 
    -webkit-transform: translate3d(82vw, 107vh, 0)
            transform: translate3d(82vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(90vw, -135vh, 0)
            transform: translate3d(90vw, -135vh, 0)
  

.circle-container:nth-child(86) .circle 
  -webkit-animation-delay: 1075ms
          animation-delay: 1075ms

.circle-container:nth-child(87) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-87
          animation-name: move-frames-87
  -webkit-animation-duration: 33200ms
          animation-duration: 33200ms
  -webkit-animation-delay: 22278ms
          animation-delay: 22278ms

@-webkit-keyframes move-frames-87 
  from 
    -webkit-transform: translate3d(82vw, 109vh, 0)
            transform: translate3d(82vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(37vw, -124vh, 0)
            transform: translate3d(37vw, -124vh, 0)
  

@keyframes move-frames-87 
  from 
    -webkit-transform: translate3d(82vw, 109vh, 0)
            transform: translate3d(82vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(37vw, -124vh, 0)
            transform: translate3d(37vw, -124vh, 0)
  

.circle-container:nth-child(87) .circle 
  -webkit-animation-delay: 1474ms
          animation-delay: 1474ms

.circle-container:nth-child(88) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-88
          animation-name: move-frames-88
  -webkit-animation-duration: 29265ms
          animation-duration: 29265ms
  -webkit-animation-delay: 29935ms
          animation-delay: 29935ms

@-webkit-keyframes move-frames-88 
  from 
    -webkit-transform: translate3d(76vw, 109vh, 0)
            transform: translate3d(76vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(49vw, -122vh, 0)
            transform: translate3d(49vw, -122vh, 0)
  

@keyframes move-frames-88 
  from 
    -webkit-transform: translate3d(76vw, 109vh, 0)
            transform: translate3d(76vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(49vw, -122vh, 0)
            transform: translate3d(49vw, -122vh, 0)
  

.circle-container:nth-child(88) .circle 
  -webkit-animation-delay: 972ms
          animation-delay: 972ms

.circle-container:nth-child(89) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-89
          animation-name: move-frames-89
  -webkit-animation-duration: 35965ms
          animation-duration: 35965ms
  -webkit-animation-delay: 11285ms
          animation-delay: 11285ms

@-webkit-keyframes move-frames-89 
  from 
    -webkit-transform: translate3d(81vw, 107vh, 0)
            transform: translate3d(81vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -111vh, 0)
            transform: translate3d(41vw, -111vh, 0)
  

@keyframes move-frames-89 
  from 
    -webkit-transform: translate3d(81vw, 107vh, 0)
            transform: translate3d(81vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -111vh, 0)
            transform: translate3d(41vw, -111vh, 0)
  

.circle-container:nth-child(89) .circle 
  -webkit-animation-delay: 2073ms
          animation-delay: 2073ms

.circle-container:nth-child(90) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-90
          animation-name: move-frames-90
  -webkit-animation-duration: 31881ms
          animation-duration: 31881ms
  -webkit-animation-delay: 1489ms
          animation-delay: 1489ms

@-webkit-keyframes move-frames-90 
  from 
    -webkit-transform: translate3d(7vw, 102vh, 0)
            transform: translate3d(7vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(98vw, -118vh, 0)
            transform: translate3d(98vw, -118vh, 0)
  

@keyframes move-frames-90 
  from 
    -webkit-transform: translate3d(7vw, 102vh, 0)
            transform: translate3d(7vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(98vw, -118vh, 0)
            transform: translate3d(98vw, -118vh, 0)
  

.circle-container:nth-child(90) .circle 
  -webkit-animation-delay: 2194ms
          animation-delay: 2194ms

.circle-container:nth-child(91) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-91
          animation-name: move-frames-91
  -webkit-animation-duration: 28187ms
          animation-duration: 28187ms
  -webkit-animation-delay: 14219ms
          animation-delay: 14219ms

@-webkit-keyframes move-frames-91 
  from 
    -webkit-transform: translate3d(55vw, 107vh, 0)
            transform: translate3d(55vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -127vh, 0)
            transform: translate3d(75vw, -127vh, 0)
  

@keyframes move-frames-91 
  from 
    -webkit-transform: translate3d(55vw, 107vh, 0)
            transform: translate3d(55vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -127vh, 0)
            transform: translate3d(75vw, -127vh, 0)
  

.circle-container:nth-child(91) .circle 
  -webkit-animation-delay: 1085ms
          animation-delay: 1085ms

.circle-container:nth-child(92) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-92
          animation-name: move-frames-92
  -webkit-animation-duration: 36932ms
          animation-duration: 36932ms
  -webkit-animation-delay: 30055ms
          animation-delay: 30055ms

@-webkit-keyframes move-frames-92 
  from 
    -webkit-transform: translate3d(61vw, 105vh, 0)
            transform: translate3d(61vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -108vh, 0)
            transform: translate3d(87vw, -108vh, 0)
  

@keyframes move-frames-92 
  from 
    -webkit-transform: translate3d(61vw, 105vh, 0)
            transform: translate3d(61vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -108vh, 0)
            transform: translate3d(87vw, -108vh, 0)
  

.circle-container:nth-child(92) .circle 
  -webkit-animation-delay: 390ms
          animation-delay: 390ms

.circle-container:nth-child(93) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-93
          animation-name: move-frames-93
  -webkit-animation-duration: 31090ms
          animation-duration: 31090ms
  -webkit-animation-delay: 3478ms
          animation-delay: 3478ms

@-webkit-keyframes move-frames-93 
  from 
    -webkit-transform: translate3d(39vw, 107vh, 0)
            transform: translate3d(39vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(53vw, -118vh, 0)
            transform: translate3d(53vw, -118vh, 0)
  

@keyframes move-frames-93 
  from 
    -webkit-transform: translate3d(39vw, 107vh, 0)
            transform: translate3d(39vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(53vw, -118vh, 0)
            transform: translate3d(53vw, -118vh, 0)
  

.circle-container:nth-child(93) .circle 
  -webkit-animation-delay: 2685ms
          animation-delay: 2685ms

.circle-container:nth-child(94) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-94
          animation-name: move-frames-94
  -webkit-animation-duration: 35729ms
          animation-duration: 35729ms
  -webkit-animation-delay: 8336ms
          animation-delay: 8336ms

@-webkit-keyframes move-frames-94 
  from 
    -webkit-transform: translate3d(18vw, 107vh, 0)
            transform: translate3d(18vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(5vw, -123vh, 0)
            transform: translate3d(5vw, -123vh, 0)
  

@keyframes move-frames-94 
  from 
    -webkit-transform: translate3d(18vw, 107vh, 0)
            transform: translate3d(18vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(5vw, -123vh, 0)
            transform: translate3d(5vw, -123vh, 0)
  

.circle-container:nth-child(94) .circle 
  -webkit-animation-delay: 985ms
          animation-delay: 985ms

.circle-container:nth-child(95) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-95
          animation-name: move-frames-95
  -webkit-animation-duration: 36773ms
          animation-duration: 36773ms
  -webkit-animation-delay: 30262ms
          animation-delay: 30262ms

@-webkit-keyframes move-frames-95 
  from 
    -webkit-transform: translate3d(23vw, 110vh, 0)
            transform: translate3d(23vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -129vh, 0)
            transform: translate3d(16vw, -129vh, 0)
  

@keyframes move-frames-95 
  from 
    -webkit-transform: translate3d(23vw, 110vh, 0)
            transform: translate3d(23vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -129vh, 0)
            transform: translate3d(16vw, -129vh, 0)
  

.circle-container:nth-child(95) .circle 
  -webkit-animation-delay: 2980ms
          animation-delay: 2980ms

.circle-container:nth-child(96) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-96
          animation-name: move-frames-96
  -webkit-animation-duration: 33849ms
          animation-duration: 33849ms
  -webkit-animation-delay: 12993ms
          animation-delay: 12993ms

@-webkit-keyframes move-frames-96 
  from 
    -webkit-transform: translate3d(69vw, 102vh, 0)
            transform: translate3d(69vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(6vw, -126vh, 0)
            transform: translate3d(6vw, -126vh, 0)
  

@keyframes move-frames-96 
  from 
    -webkit-transform: translate3d(69vw, 102vh, 0)
            transform: translate3d(69vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(6vw, -126vh, 0)
            transform: translate3d(6vw, -126vh, 0)
  

.circle-container:nth-child(96) .circle 
  -webkit-animation-delay: 3423ms
          animation-delay: 3423ms

.circle-container:nth-child(97) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-97
          animation-name: move-frames-97
  -webkit-animation-duration: 29341ms
          animation-duration: 29341ms
  -webkit-animation-delay: 31585ms
          animation-delay: 31585ms

@-webkit-keyframes move-frames-97 
  from 
    -webkit-transform: translate3d(51vw, 103vh, 0)
            transform: translate3d(51vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(61vw, -128vh, 0)
            transform: translate3d(61vw, -128vh, 0)
  

@keyframes move-frames-97 
  from 
    -webkit-transform: translate3d(51vw, 103vh, 0)
            transform: translate3d(51vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(61vw, -128vh, 0)
            transform: translate3d(61vw, -128vh, 0)
  

.circle-container:nth-child(97) .circle 
  -webkit-animation-delay: 155ms
          animation-delay: 155ms

.circle-container:nth-child(98) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-98
          animation-name: move-frames-98
  -webkit-animation-duration: 31101ms
          animation-duration: 31101ms
  -webkit-animation-delay: 11460ms
          animation-delay: 11460ms

@-webkit-keyframes move-frames-98 
  from 
    -webkit-transform: translate3d(69vw, 106vh, 0)
            transform: translate3d(69vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(32vw, -114vh, 0)
            transform: translate3d(32vw, -114vh, 0)
  

@keyframes move-frames-98 
  from 
    -webkit-transform: translate3d(69vw, 106vh, 0)
            transform: translate3d(69vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(32vw, -114vh, 0)
            transform: translate3d(32vw, -114vh, 0)
  

.circle-container:nth-child(98) .circle 
  -webkit-animation-delay: 1205ms
          animation-delay: 1205ms

.circle-container:nth-child(99) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-99
          animation-name: move-frames-99
  -webkit-animation-duration: 35277ms
          animation-duration: 35277ms
  -webkit-animation-delay: 14787ms
          animation-delay: 14787ms

@-webkit-keyframes move-frames-99 
  from 
    -webkit-transform: translate3d(53vw, 102vh, 0)
            transform: translate3d(53vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -118vh, 0)
            transform: translate3d(3vw, -118vh, 0)
  

@keyframes move-frames-99 
  from 
    -webkit-transform: translate3d(53vw, 102vh, 0)
            transform: translate3d(53vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -118vh, 0)
            transform: translate3d(3vw, -118vh, 0)
  

.circle-container:nth-child(99) .circle 
  -webkit-animation-delay: 760ms
          animation-delay: 760ms

.circle-container:nth-child(100) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-100
          animation-name: move-frames-100
  -webkit-animation-duration: 30340ms
          animation-duration: 30340ms
  -webkit-animation-delay: 24440ms
          animation-delay: 24440ms

@-webkit-keyframes move-frames-100 
  from 
    -webkit-transform: translate3d(77vw, 104vh, 0)
            transform: translate3d(77vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(10vw, -113vh, 0)
            transform: translate3d(10vw, -113vh, 0)
  

@keyframes move-frames-100 
  from 
    -webkit-transform: translate3d(77vw, 104vh, 0)
            transform: translate3d(77vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(10vw, -113vh, 0)
            transform: translate3d(10vw, -113vh, 0)
  

.circle-container:nth-child(100) .circle 
  -webkit-animation-delay: 1256ms
          animation-delay: 1256ms

.circle-container:nth-child(101) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-101
          animation-name: move-frames-101
  -webkit-animation-duration: 30447ms
          animation-duration: 30447ms
  -webkit-animation-delay: 8948ms
          animation-delay: 8948ms

@-webkit-keyframes move-frames-101 
  from 
    -webkit-transform: translate3d(43vw, 103vh, 0)
            transform: translate3d(43vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(60vw, -104vh, 0)
            transform: translate3d(60vw, -104vh, 0)
  

@keyframes move-frames-101 
  from 
    -webkit-transform: translate3d(43vw, 103vh, 0)
            transform: translate3d(43vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(60vw, -104vh, 0)
            transform: translate3d(60vw, -104vh, 0)
  

.circle-container:nth-child(101) .circle 
  -webkit-animation-delay: 1157ms
          animation-delay: 1157ms

.circle-container:nth-child(102) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-102
          animation-name: move-frames-102
  -webkit-animation-duration: 29051ms
          animation-duration: 29051ms
  -webkit-animation-delay: 27425ms
          animation-delay: 27425ms

@-webkit-keyframes move-frames-102 
  from 
    -webkit-transform: translate3d(26vw, 102vh, 0)
            transform: translate3d(26vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(99vw, -126vh, 0)
            transform: translate3d(99vw, -126vh, 0)
  

@keyframes move-frames-102 
  from 
    -webkit-transform: translate3d(26vw, 102vh, 0)
            transform: translate3d(26vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(99vw, -126vh, 0)
            transform: translate3d(99vw, -126vh, 0)
  

.circle-container:nth-child(102) .circle 
  -webkit-animation-delay: 2159ms
          animation-delay: 2159ms

.circle-container:nth-child(103) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-103
          animation-name: move-frames-103
  -webkit-animation-duration: 32596ms
          animation-duration: 32596ms
  -webkit-animation-delay: 3864ms
          animation-delay: 3864ms

@-webkit-keyframes move-frames-103 
  from 
    -webkit-transform: translate3d(50vw, 104vh, 0)
            transform: translate3d(50vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(26vw, -126vh, 0)
            transform: translate3d(26vw, -126vh, 0)
  

@keyframes move-frames-103 
  from 
    -webkit-transform: translate3d(50vw, 104vh, 0)
            transform: translate3d(50vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(26vw, -126vh, 0)
            transform: translate3d(26vw, -126vh, 0)
  

.circle-container:nth-child(103) .circle 
  -webkit-animation-delay: 2872ms
          animation-delay: 2872ms

.circle-container:nth-child(104) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-104
          animation-name: move-frames-104
  -webkit-animation-duration: 28481ms
          animation-duration: 28481ms
  -webkit-animation-delay: 26024ms
          animation-delay: 26024ms

@-webkit-keyframes move-frames-104 
  from 
    -webkit-transform: translate3d(7vw, 110vh, 0)
            transform: translate3d(7vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -113vh, 0)
            transform: translate3d(34vw, -113vh, 0)
  

@keyframes move-frames-104 
  from 
    -webkit-transform: translate3d(7vw, 110vh, 0)
            transform: translate3d(7vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -113vh, 0)
            transform: translate3d(34vw, -113vh, 0)
  

.circle-container:nth-child(104) .circle 
  -webkit-animation-delay: 1124ms
          animation-delay: 1124ms

.circle-container:nth-child(105) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-105
          animation-name: move-frames-105
  -webkit-animation-duration: 33667ms
          animation-duration: 33667ms
  -webkit-animation-delay: 14200ms
          animation-delay: 14200ms

@-webkit-keyframes move-frames-105 
  from 
    -webkit-transform: translate3d(69vw, 107vh, 0)
            transform: translate3d(69vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(58vw, -127vh, 0)
            transform: translate3d(58vw, -127vh, 0)
  

@keyframes move-frames-105 
  from 
    -webkit-transform: translate3d(69vw, 107vh, 0)
            transform: translate3d(69vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(58vw, -127vh, 0)
            transform: translate3d(58vw, -127vh, 0)
  

.circle-container:nth-child(105) .circle 
  -webkit-animation-delay: 3623ms
          animation-delay: 3623ms

.circle-container:nth-child(106) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-106
          animation-name: move-frames-106
  -webkit-animation-duration: 28983ms
          animation-duration: 28983ms
  -webkit-animation-delay: 12141ms
          animation-delay: 12141ms

@-webkit-keyframes move-frames-106 
  from 
    -webkit-transform: translate3d(3vw, 105vh, 0)
            transform: translate3d(3vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(56vw, -115vh, 0)
            transform: translate3d(56vw, -115vh, 0)
  

@keyframes move-frames-106 
  from 
    -webkit-transform: translate3d(3vw, 105vh, 0)
            transform: translate3d(3vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(56vw, -115vh, 0)
            transform: translate3d(56vw, -115vh, 0)
  

.circle-container:nth-child(106) .circle 
  -webkit-animation-delay: 1970ms
          animation-delay: 1970ms

.circle-container:nth-child(107) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-107
          animation-name: move-frames-107
  -webkit-animation-duration: 30853ms
          animation-duration: 30853ms
  -webkit-animation-delay: 33095ms
          animation-delay: 33095ms

@-webkit-keyframes move-frames-107 
  from 
    -webkit-transform: translate3d(100vw, 109vh, 0)
            transform: translate3d(100vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -113vh, 0)
            transform: translate3d(27vw, -113vh, 0)
  

@keyframes move-frames-107 
  from 
    -webkit-transform: translate3d(100vw, 109vh, 0)
            transform: translate3d(100vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -113vh, 0)
            transform: translate3d(27vw, -113vh, 0)
  

.circle-container:nth-child(107) .circle 
  -webkit-animation-delay: 3193ms
          animation-delay: 3193ms

.circle-container:nth-child(108) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-108
          animation-name: move-frames-108
  -webkit-animation-duration: 32850ms
          animation-duration: 32850ms
  -webkit-animation-delay: 4199ms
          animation-delay: 4199ms

@-webkit-keyframes move-frames-108 
  from 
    -webkit-transform: translate3d(32vw, 102vh, 0)
            transform: translate3d(32vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(37vw, -125vh, 0)
            transform: translate3d(37vw, -125vh, 0)
  

@keyframes move-frames-108 
  from 
    -webkit-transform: translate3d(32vw, 102vh, 0)
            transform: translate3d(32vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(37vw, -125vh, 0)
            transform: translate3d(37vw, -125vh, 0)
  

.circle-container:nth-child(108) .circle 
  -webkit-animation-delay: 201ms
          animation-delay: 201ms

.circle-container:nth-child(109) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-109
          animation-name: move-frames-109
  -webkit-animation-duration: 30408ms
          animation-duration: 30408ms
  -webkit-animation-delay: 24574ms
          animation-delay: 24574ms

@-webkit-keyframes move-frames-109 
  from 
    -webkit-transform: translate3d(16vw, 102vh, 0)
            transform: translate3d(16vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(60vw, -107vh, 0)
            transform: translate3d(60vw, -107vh, 0)
  

@keyframes move-frames-109 
  from 
    -webkit-transform: translate3d(16vw, 102vh, 0)
            transform: translate3d(16vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(60vw, -107vh, 0)
            transform: translate3d(60vw, -107vh, 0)
  

.circle-container:nth-child(109) .circle 
  -webkit-animation-delay: 2811ms
          animation-delay: 2811ms

.circle-container:nth-child(110) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-110
          animation-name: move-frames-110
  -webkit-animation-duration: 34722ms
          animation-duration: 34722ms
  -webkit-animation-delay: 31166ms
          animation-delay: 31166ms

@-webkit-keyframes move-frames-110 
  from 
    -webkit-transform: translate3d(86vw, 109vh, 0)
            transform: translate3d(86vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -126vh, 0)
            transform: translate3d(16vw, -126vh, 0)
  

@keyframes move-frames-110 
  from 
    -webkit-transform: translate3d(86vw, 109vh, 0)
            transform: translate3d(86vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(16vw, -126vh, 0)
            transform: translate3d(16vw, -126vh, 0)
  

.circle-container:nth-child(110) .circle 
  -webkit-animation-delay: 2535ms
          animation-delay: 2535ms

.circle-container:nth-child(111) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-111
          animation-name: move-frames-111
  -webkit-animation-duration: 36014ms
          animation-duration: 36014ms
  -webkit-animation-delay: 16558ms
          animation-delay: 16558ms

@-webkit-keyframes move-frames-111 
  from 
    -webkit-transform: translate3d(70vw, 102vh, 0)
            transform: translate3d(70vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(43vw, -107vh, 0)
            transform: translate3d(43vw, -107vh, 0)
  

@keyframes move-frames-111 
  from 
    -webkit-transform: translate3d(70vw, 102vh, 0)
            transform: translate3d(70vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(43vw, -107vh, 0)
            transform: translate3d(43vw, -107vh, 0)
  

.circle-container:nth-child(111) .circle 
  -webkit-animation-delay: 2732ms
          animation-delay: 2732ms

.circle-container:nth-child(112) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-112
          animation-name: move-frames-112
  -webkit-animation-duration: 33698ms
          animation-duration: 33698ms
  -webkit-animation-delay: 13437ms
          animation-delay: 13437ms

@-webkit-keyframes move-frames-112 
  from 
    -webkit-transform: translate3d(32vw, 108vh, 0)
            transform: translate3d(32vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -128vh, 0)
            transform: translate3d(68vw, -128vh, 0)
  

@keyframes move-frames-112 
  from 
    -webkit-transform: translate3d(32vw, 108vh, 0)
            transform: translate3d(32vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -128vh, 0)
            transform: translate3d(68vw, -128vh, 0)
  

.circle-container:nth-child(112) .circle 
  -webkit-animation-delay: 1809ms
          animation-delay: 1809ms

.circle-container:nth-child(113) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-113
          animation-name: move-frames-113
  -webkit-animation-duration: 33952ms
          animation-duration: 33952ms
  -webkit-animation-delay: 9052ms
          animation-delay: 9052ms

@-webkit-keyframes move-frames-113 
  from 
    -webkit-transform: translate3d(70vw, 101vh, 0)
            transform: translate3d(70vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(39vw, -110vh, 0)
            transform: translate3d(39vw, -110vh, 0)
  

@keyframes move-frames-113 
  from 
    -webkit-transform: translate3d(70vw, 101vh, 0)
            transform: translate3d(70vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(39vw, -110vh, 0)
            transform: translate3d(39vw, -110vh, 0)
  

.circle-container:nth-child(113) .circle 
  -webkit-animation-delay: 3860ms
          animation-delay: 3860ms

.circle-container:nth-child(114) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-114
          animation-name: move-frames-114
  -webkit-animation-duration: 33025ms
          animation-duration: 33025ms
  -webkit-animation-delay: 26408ms
          animation-delay: 26408ms

@-webkit-keyframes move-frames-114 
  from 
    -webkit-transform: translate3d(92vw, 106vh, 0)
            transform: translate3d(92vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(39vw, -129vh, 0)
            transform: translate3d(39vw, -129vh, 0)
  

@keyframes move-frames-114 
  from 
    -webkit-transform: translate3d(92vw, 106vh, 0)
            transform: translate3d(92vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(39vw, -129vh, 0)
            transform: translate3d(39vw, -129vh, 0)
  

.circle-container:nth-child(114) .circle 
  -webkit-animation-delay: 472ms
          animation-delay: 472ms

.circle-container:nth-child(115) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-115
          animation-name: move-frames-115
  -webkit-animation-duration: 31981ms
          animation-duration: 31981ms
  -webkit-animation-delay: 19237ms
          animation-delay: 19237ms

@-webkit-keyframes move-frames-115 
  from 
    -webkit-transform: translate3d(8vw, 106vh, 0)
            transform: translate3d(8vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(83vw, -111vh, 0)
            transform: translate3d(83vw, -111vh, 0)
  

@keyframes move-frames-115 
  from 
    -webkit-transform: translate3d(8vw, 106vh, 0)
            transform: translate3d(8vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(83vw, -111vh, 0)
            transform: translate3d(83vw, -111vh, 0)
  

.circle-container:nth-child(115) .circle 
  -webkit-animation-delay: 800ms
          animation-delay: 800ms

.circle-container:nth-child(116) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-116
          animation-name: move-frames-116
  -webkit-animation-duration: 36056ms
          animation-duration: 36056ms
  -webkit-animation-delay: 13045ms
          animation-delay: 13045ms

@-webkit-keyframes move-frames-116 
  from 
    -webkit-transform: translate3d(86vw, 102vh, 0)
            transform: translate3d(86vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(35vw, -132vh, 0)
            transform: translate3d(35vw, -132vh, 0)
  

@keyframes move-frames-116 
  from 
    -webkit-transform: translate3d(86vw, 102vh, 0)
            transform: translate3d(86vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(35vw, -132vh, 0)
            transform: translate3d(35vw, -132vh, 0)
  

.circle-container:nth-child(116) .circle 
  -webkit-animation-delay: 2116ms
          animation-delay: 2116ms

.circle-container:nth-child(117) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-117
          animation-name: move-frames-117
  -webkit-animation-duration: 33990ms
          animation-duration: 33990ms
  -webkit-animation-delay: 20295ms
          animation-delay: 20295ms

@-webkit-keyframes move-frames-117 
  from 
    -webkit-transform: translate3d(21vw, 108vh, 0)
            transform: translate3d(21vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(9vw, -134vh, 0)
            transform: translate3d(9vw, -134vh, 0)
  

@keyframes move-frames-117 
  from 
    -webkit-transform: translate3d(21vw, 108vh, 0)
            transform: translate3d(21vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(9vw, -134vh, 0)
            transform: translate3d(9vw, -134vh, 0)
  

.circle-container:nth-child(117) .circle 
  -webkit-animation-delay: 1697ms
          animation-delay: 1697ms

.circle-container:nth-child(118) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-118
          animation-name: move-frames-118
  -webkit-animation-duration: 35987ms
          animation-duration: 35987ms
  -webkit-animation-delay: 15350ms
          animation-delay: 15350ms

@-webkit-keyframes move-frames-118 
  from 
    -webkit-transform: translate3d(89vw, 101vh, 0)
            transform: translate3d(89vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -131vh, 0)
            transform: translate3d(30vw, -131vh, 0)
  

@keyframes move-frames-118 
  from 
    -webkit-transform: translate3d(89vw, 101vh, 0)
            transform: translate3d(89vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -131vh, 0)
            transform: translate3d(30vw, -131vh, 0)
  

.circle-container:nth-child(118) .circle 
  -webkit-animation-delay: 3912ms
          animation-delay: 3912ms

.circle-container:nth-child(119) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-119
          animation-name: move-frames-119
  -webkit-animation-duration: 33714ms
          animation-duration: 33714ms
  -webkit-animation-delay: 32625ms
          animation-delay: 32625ms

@-webkit-keyframes move-frames-119 
  from 
    -webkit-transform: translate3d(88vw, 106vh, 0)
            transform: translate3d(88vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(82vw, -116vh, 0)
            transform: translate3d(82vw, -116vh, 0)
  

@keyframes move-frames-119 
  from 
    -webkit-transform: translate3d(88vw, 106vh, 0)
            transform: translate3d(88vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(82vw, -116vh, 0)
            transform: translate3d(82vw, -116vh, 0)
  

.circle-container:nth-child(119) .circle 
  -webkit-animation-delay: 3772ms
          animation-delay: 3772ms

.circle-container:nth-child(120) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-120
          animation-name: move-frames-120
  -webkit-animation-duration: 31871ms
          animation-duration: 31871ms
  -webkit-animation-delay: 22955ms
          animation-delay: 22955ms

@-webkit-keyframes move-frames-120 
  from 
    -webkit-transform: translate3d(38vw, 107vh, 0)
            transform: translate3d(38vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -118vh, 0)
            transform: translate3d(3vw, -118vh, 0)
  

@keyframes move-frames-120 
  from 
    -webkit-transform: translate3d(38vw, 107vh, 0)
            transform: translate3d(38vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -118vh, 0)
            transform: translate3d(3vw, -118vh, 0)
  

.circle-container:nth-child(120) .circle 
  -webkit-animation-delay: 3168ms
          animation-delay: 3168ms

.circle-container:nth-child(121) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-121
          animation-name: move-frames-121
  -webkit-animation-duration: 31008ms
          animation-duration: 31008ms
  -webkit-animation-delay: 33753ms
          animation-delay: 33753ms

@-webkit-keyframes move-frames-121 
  from 
    -webkit-transform: translate3d(30vw, 109vh, 0)
            transform: translate3d(30vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(93vw, -120vh, 0)
            transform: translate3d(93vw, -120vh, 0)
  

@keyframes move-frames-121 
  from 
    -webkit-transform: translate3d(30vw, 109vh, 0)
            transform: translate3d(30vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(93vw, -120vh, 0)
            transform: translate3d(93vw, -120vh, 0)
  

.circle-container:nth-child(121) .circle 
  -webkit-animation-delay: 2394ms
          animation-delay: 2394ms

.circle-container:nth-child(122) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-122
          animation-name: move-frames-122
  -webkit-animation-duration: 28515ms
          animation-duration: 28515ms
  -webkit-animation-delay: 12606ms
          animation-delay: 12606ms

@-webkit-keyframes move-frames-122 
  from 
    -webkit-transform: translate3d(80vw, 105vh, 0)
            transform: translate3d(80vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -132vh, 0)
            transform: translate3d(76vw, -132vh, 0)
  

@keyframes move-frames-122 
  from 
    -webkit-transform: translate3d(80vw, 105vh, 0)
            transform: translate3d(80vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -132vh, 0)
            transform: translate3d(76vw, -132vh, 0)
  

.circle-container:nth-child(122) .circle 
  -webkit-animation-delay: 2153ms
          animation-delay: 2153ms

.circle-container:nth-child(123) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-123
          animation-name: move-frames-123
  -webkit-animation-duration: 32448ms
          animation-duration: 32448ms
  -webkit-animation-delay: 32437ms
          animation-delay: 32437ms

@-webkit-keyframes move-frames-123 
  from 
    -webkit-transform: translate3d(43vw, 107vh, 0)
            transform: translate3d(43vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(36vw, -122vh, 0)
            transform: translate3d(36vw, -122vh, 0)
  

@keyframes move-frames-123 
  from 
    -webkit-transform: translate3d(43vw, 107vh, 0)
            transform: translate3d(43vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(36vw, -122vh, 0)
            transform: translate3d(36vw, -122vh, 0)
  

.circle-container:nth-child(123) .circle 
  -webkit-animation-delay: 2694ms
          animation-delay: 2694ms

.circle-container:nth-child(124) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-124
          animation-name: move-frames-124
  -webkit-animation-duration: 33129ms
          animation-duration: 33129ms
  -webkit-animation-delay: 24906ms
          animation-delay: 24906ms

@-webkit-keyframes move-frames-124 
  from 
    -webkit-transform: translate3d(62vw, 105vh, 0)
            transform: translate3d(62vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(62vw, -123vh, 0)
            transform: translate3d(62vw, -123vh, 0)
  

@keyframes move-frames-124 
  from 
    -webkit-transform: translate3d(62vw, 105vh, 0)
            transform: translate3d(62vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(62vw, -123vh, 0)
            transform: translate3d(62vw, -123vh, 0)
  

.circle-container:nth-child(124) .circle 
  -webkit-animation-delay: 237ms
          animation-delay: 237ms

.circle-container:nth-child(125) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-125
          animation-name: move-frames-125
  -webkit-animation-duration: 30262ms
          animation-duration: 30262ms
  -webkit-animation-delay: 16441ms
          animation-delay: 16441ms

@-webkit-keyframes move-frames-125 
  from 
    -webkit-transform: translate3d(16vw, 102vh, 0)
            transform: translate3d(16vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(62vw, -131vh, 0)
            transform: translate3d(62vw, -131vh, 0)
  

@keyframes move-frames-125 
  from 
    -webkit-transform: translate3d(16vw, 102vh, 0)
            transform: translate3d(16vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(62vw, -131vh, 0)
            transform: translate3d(62vw, -131vh, 0)
  

.circle-container:nth-child(125) .circle 
  -webkit-animation-delay: 2538ms
          animation-delay: 2538ms

.circle-container:nth-child(126) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-126
          animation-name: move-frames-126
  -webkit-animation-duration: 31804ms
          animation-duration: 31804ms
  -webkit-animation-delay: 20133ms
          animation-delay: 20133ms

@-webkit-keyframes move-frames-126 
  from 
    -webkit-transform: translate3d(61vw, 106vh, 0)
            transform: translate3d(61vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -121vh, 0)
            transform: translate3d(31vw, -121vh, 0)
  

@keyframes move-frames-126 
  from 
    -webkit-transform: translate3d(61vw, 106vh, 0)
            transform: translate3d(61vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -121vh, 0)
            transform: translate3d(31vw, -121vh, 0)
  

.circle-container:nth-child(126) .circle 
  -webkit-animation-delay: 3852ms
          animation-delay: 3852ms

.circle-container:nth-child(127) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-127
          animation-name: move-frames-127
  -webkit-animation-duration: 32378ms
          animation-duration: 32378ms
  -webkit-animation-delay: 13731ms
          animation-delay: 13731ms

@-webkit-keyframes move-frames-127 
  from 
    -webkit-transform: translate3d(7vw, 105vh, 0)
            transform: translate3d(7vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(19vw, -109vh, 0)
            transform: translate3d(19vw, -109vh, 0)
  

@keyframes move-frames-127 
  from 
    -webkit-transform: translate3d(7vw, 105vh, 0)
            transform: translate3d(7vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(19vw, -109vh, 0)
            transform: translate3d(19vw, -109vh, 0)
  

.circle-container:nth-child(127) .circle 
  -webkit-animation-delay: 2822ms
          animation-delay: 2822ms

.circle-container:nth-child(128) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-128
          animation-name: move-frames-128
  -webkit-animation-duration: 29857ms
          animation-duration: 29857ms
  -webkit-animation-delay: 16345ms
          animation-delay: 16345ms

@-webkit-keyframes move-frames-128 
  from 
    -webkit-transform: translate3d(50vw, 101vh, 0)
            transform: translate3d(50vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(49vw, -105vh, 0)
            transform: translate3d(49vw, -105vh, 0)
  

@keyframes move-frames-128 
  from 
    -webkit-transform: translate3d(50vw, 101vh, 0)
            transform: translate3d(50vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(49vw, -105vh, 0)
            transform: translate3d(49vw, -105vh, 0)
  

.circle-container:nth-child(128) .circle 
  -webkit-animation-delay: 1024ms
          animation-delay: 1024ms

.circle-container:nth-child(129) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-129
          animation-name: move-frames-129
  -webkit-animation-duration: 32066ms
          animation-duration: 32066ms
  -webkit-animation-delay: 14739ms
          animation-delay: 14739ms

@-webkit-keyframes move-frames-129 
  from 
    -webkit-transform: translate3d(89vw, 101vh, 0)
            transform: translate3d(89vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(51vw, -122vh, 0)
            transform: translate3d(51vw, -122vh, 0)
  

@keyframes move-frames-129 
  from 
    -webkit-transform: translate3d(89vw, 101vh, 0)
            transform: translate3d(89vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(51vw, -122vh, 0)
            transform: translate3d(51vw, -122vh, 0)
  

.circle-container:nth-child(129) .circle 
  -webkit-animation-delay: 829ms
          animation-delay: 829ms

.circle-container:nth-child(130) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-130
          animation-name: move-frames-130
  -webkit-animation-duration: 34962ms
          animation-duration: 34962ms
  -webkit-animation-delay: 34609ms
          animation-delay: 34609ms

@-webkit-keyframes move-frames-130 
  from 
    -webkit-transform: translate3d(67vw, 105vh, 0)
            transform: translate3d(67vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -107vh, 0)
            transform: translate3d(50vw, -107vh, 0)
  

@keyframes move-frames-130 
  from 
    -webkit-transform: translate3d(67vw, 105vh, 0)
            transform: translate3d(67vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -107vh, 0)
            transform: translate3d(50vw, -107vh, 0)
  

.circle-container:nth-child(130) .circle 
  -webkit-animation-delay: 470ms
          animation-delay: 470ms

.circle-container:nth-child(131) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-131
          animation-name: move-frames-131
  -webkit-animation-duration: 34526ms
          animation-duration: 34526ms
  -webkit-animation-delay: 31752ms
          animation-delay: 31752ms

@-webkit-keyframes move-frames-131 
  from 
    -webkit-transform: translate3d(28vw, 102vh, 0)
            transform: translate3d(28vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -128vh, 0)
            transform: translate3d(76vw, -128vh, 0)
  

@keyframes move-frames-131 
  from 
    -webkit-transform: translate3d(28vw, 102vh, 0)
            transform: translate3d(28vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -128vh, 0)
            transform: translate3d(76vw, -128vh, 0)
  

.circle-container:nth-child(131) .circle 
  -webkit-animation-delay: 3980ms
          animation-delay: 3980ms

.circle-container:nth-child(132) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-132
          animation-name: move-frames-132
  -webkit-animation-duration: 32483ms
          animation-duration: 32483ms
  -webkit-animation-delay: 27240ms
          animation-delay: 27240ms

@-webkit-keyframes move-frames-132 
  from 
    -webkit-transform: translate3d(99vw, 105vh, 0)
            transform: translate3d(99vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(70vw, -112vh, 0)
            transform: translate3d(70vw, -112vh, 0)
  

@keyframes move-frames-132 
  from 
    -webkit-transform: translate3d(99vw, 105vh, 0)
            transform: translate3d(99vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(70vw, -112vh, 0)
            transform: translate3d(70vw, -112vh, 0)
  

.circle-container:nth-child(132) .circle 
  -webkit-animation-delay: 2111ms
          animation-delay: 2111ms

.circle-container:nth-child(133) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-133
          animation-name: move-frames-133
  -webkit-animation-duration: 31333ms
          animation-duration: 31333ms
  -webkit-animation-delay: 19224ms
          animation-delay: 19224ms

@-webkit-keyframes move-frames-133 
  from 
    -webkit-transform: translate3d(87vw, 101vh, 0)
            transform: translate3d(87vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -124vh, 0)
            transform: translate3d(31vw, -124vh, 0)
  

@keyframes move-frames-133 
  from 
    -webkit-transform: translate3d(87vw, 101vh, 0)
            transform: translate3d(87vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -124vh, 0)
            transform: translate3d(31vw, -124vh, 0)
  

.circle-container:nth-child(133) .circle 
  -webkit-animation-delay: 983ms
          animation-delay: 983ms

.circle-container:nth-child(134) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-134
          animation-name: move-frames-134
  -webkit-animation-duration: 28051ms
          animation-duration: 28051ms
  -webkit-animation-delay: 31410ms
          animation-delay: 31410ms

@-webkit-keyframes move-frames-134 
  from 
    -webkit-transform: translate3d(68vw, 101vh, 0)
            transform: translate3d(68vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(35vw, -113vh, 0)
            transform: translate3d(35vw, -113vh, 0)
  

@keyframes move-frames-134 
  from 
    -webkit-transform: translate3d(68vw, 101vh, 0)
            transform: translate3d(68vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(35vw, -113vh, 0)
            transform: translate3d(35vw, -113vh, 0)
  

.circle-container:nth-child(134) .circle 
  -webkit-animation-delay: 2211ms
          animation-delay: 2211ms

.circle-container:nth-child(135) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-135
          animation-name: move-frames-135
  -webkit-animation-duration: 30897ms
          animation-duration: 30897ms
  -webkit-animation-delay: 15595ms
          animation-delay: 15595ms

@-webkit-keyframes move-frames-135 
  from 
    -webkit-transform: translate3d(6vw, 106vh, 0)
            transform: translate3d(6vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(8vw, -114vh, 0)
            transform: translate3d(8vw, -114vh, 0)
  

@keyframes move-frames-135 
  from 
    -webkit-transform: translate3d(6vw, 106vh, 0)
            transform: translate3d(6vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(8vw, -114vh, 0)
            transform: translate3d(8vw, -114vh, 0)
  

.circle-container:nth-child(135) .circle 
  -webkit-animation-delay: 212ms
          animation-delay: 212ms

.circle-container:nth-child(136) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-136
          animation-name: move-frames-136
  -webkit-animation-duration: 33498ms
          animation-duration: 33498ms
  -webkit-animation-delay: 31949ms
          animation-delay: 31949ms

@-webkit-keyframes move-frames-136 
  from 
    -webkit-transform: translate3d(22vw, 101vh, 0)
            transform: translate3d(22vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -107vh, 0)
            transform: translate3d(50vw, -107vh, 0)
  

@keyframes move-frames-136 
  from 
    -webkit-transform: translate3d(22vw, 101vh, 0)
            transform: translate3d(22vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -107vh, 0)
            transform: translate3d(50vw, -107vh, 0)
  

.circle-container:nth-child(136) .circle 
  -webkit-animation-delay: 366ms
          animation-delay: 366ms

.circle-container:nth-child(137) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-137
          animation-name: move-frames-137
  -webkit-animation-duration: 32947ms
          animation-duration: 32947ms
  -webkit-animation-delay: 10610ms
          animation-delay: 10610ms

@-webkit-keyframes move-frames-137 
  from 
    -webkit-transform: translate3d(7vw, 110vh, 0)
            transform: translate3d(7vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -117vh, 0)
            transform: translate3d(42vw, -117vh, 0)
  

@keyframes move-frames-137 
  from 
    -webkit-transform: translate3d(7vw, 110vh, 0)
            transform: translate3d(7vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -117vh, 0)
            transform: translate3d(42vw, -117vh, 0)
  

.circle-container:nth-child(137) .circle 
  -webkit-animation-delay: 2818ms
          animation-delay: 2818ms

.circle-container:nth-child(138) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-138
          animation-name: move-frames-138
  -webkit-animation-duration: 29938ms
          animation-duration: 29938ms
  -webkit-animation-delay: 13819ms
          animation-delay: 13819ms

@-webkit-keyframes move-frames-138 
  from 
    -webkit-transform: translate3d(85vw, 101vh, 0)
            transform: translate3d(85vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -111vh, 0)
            transform: translate3d(87vw, -111vh, 0)
  

@keyframes move-frames-138 
  from 
    -webkit-transform: translate3d(85vw, 101vh, 0)
            transform: translate3d(85vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -111vh, 0)
            transform: translate3d(87vw, -111vh, 0)
  

.circle-container:nth-child(138) .circle 
  -webkit-animation-delay: 3583ms
          animation-delay: 3583ms

.circle-container:nth-child(139) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-139
          animation-name: move-frames-139
  -webkit-animation-duration: 35925ms
          animation-duration: 35925ms
  -webkit-animation-delay: 36716ms
          animation-delay: 36716ms

@-webkit-keyframes move-frames-139 
  from 
    -webkit-transform: translate3d(9vw, 103vh, 0)
            transform: translate3d(9vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(18vw, -106vh, 0)
            transform: translate3d(18vw, -106vh, 0)
  

@keyframes move-frames-139 
  from 
    -webkit-transform: translate3d(9vw, 103vh, 0)
            transform: translate3d(9vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(18vw, -106vh, 0)
            transform: translate3d(18vw, -106vh, 0)
  

.circle-container:nth-child(139) .circle 
  -webkit-animation-delay: 3656ms
          animation-delay: 3656ms

.circle-container:nth-child(140) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-140
          animation-name: move-frames-140
  -webkit-animation-duration: 28797ms
          animation-duration: 28797ms
  -webkit-animation-delay: 12229ms
          animation-delay: 12229ms

@-webkit-keyframes move-frames-140 
  from 
    -webkit-transform: translate3d(92vw, 110vh, 0)
            transform: translate3d(92vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(21vw, -120vh, 0)
            transform: translate3d(21vw, -120vh, 0)
  

@keyframes move-frames-140 
  from 
    -webkit-transform: translate3d(92vw, 110vh, 0)
            transform: translate3d(92vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(21vw, -120vh, 0)
            transform: translate3d(21vw, -120vh, 0)
  

.circle-container:nth-child(140) .circle 
  -webkit-animation-delay: 1778ms
          animation-delay: 1778ms

.circle-container:nth-child(141) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-141
          animation-name: move-frames-141
  -webkit-animation-duration: 35605ms
          animation-duration: 35605ms
  -webkit-animation-delay: 1871ms
          animation-delay: 1871ms

@-webkit-keyframes move-frames-141 
  from 
    -webkit-transform: translate3d(73vw, 104vh, 0)
            transform: translate3d(73vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -119vh, 0)
            transform: translate3d(27vw, -119vh, 0)
  

@keyframes move-frames-141 
  from 
    -webkit-transform: translate3d(73vw, 104vh, 0)
            transform: translate3d(73vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -119vh, 0)
            transform: translate3d(27vw, -119vh, 0)
  

.circle-container:nth-child(141) .circle 
  -webkit-animation-delay: 1852ms
          animation-delay: 1852ms

.circle-container:nth-child(142) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-142
          animation-name: move-frames-142
  -webkit-animation-duration: 30905ms
          animation-duration: 30905ms
  -webkit-animation-delay: 7748ms
          animation-delay: 7748ms

@-webkit-keyframes move-frames-142 
  from 
    -webkit-transform: translate3d(52vw, 103vh, 0)
            transform: translate3d(52vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -126vh, 0)
            transform: translate3d(27vw, -126vh, 0)
  

@keyframes move-frames-142 
  from 
    -webkit-transform: translate3d(52vw, 103vh, 0)
            transform: translate3d(52vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -126vh, 0)
            transform: translate3d(27vw, -126vh, 0)
  

.circle-container:nth-child(142) .circle 
  -webkit-animation-delay: 1826ms
          animation-delay: 1826ms

.circle-container:nth-child(143) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-143
          animation-name: move-frames-143
  -webkit-animation-duration: 31167ms
          animation-duration: 31167ms
  -webkit-animation-delay: 14743ms
          animation-delay: 14743ms

@-webkit-keyframes move-frames-143 
  from 
    -webkit-transform: translate3d(100vw, 104vh, 0)
            transform: translate3d(100vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(57vw, -112vh, 0)
            transform: translate3d(57vw, -112vh, 0)
  

@keyframes move-frames-143 
  from 
    -webkit-transform: translate3d(100vw, 104vh, 0)
            transform: translate3d(100vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(57vw, -112vh, 0)
            transform: translate3d(57vw, -112vh, 0)
  

.circle-container:nth-child(143) .circle 
  -webkit-animation-delay: 1377ms
          animation-delay: 1377ms

.circle-container:nth-child(144) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-144
          animation-name: move-frames-144
  -webkit-animation-duration: 32806ms
          animation-duration: 32806ms
  -webkit-animation-delay: 10933ms
          animation-delay: 10933ms

@-webkit-keyframes move-frames-144 
  from 
    -webkit-transform: translate3d(19vw, 101vh, 0)
            transform: translate3d(19vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -123vh, 0)
            transform: translate3d(76vw, -123vh, 0)
  

@keyframes move-frames-144 
  from 
    -webkit-transform: translate3d(19vw, 101vh, 0)
            transform: translate3d(19vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -123vh, 0)
            transform: translate3d(76vw, -123vh, 0)
  

.circle-container:nth-child(144) .circle 
  -webkit-animation-delay: 2484ms
          animation-delay: 2484ms

.circle-container:nth-child(145) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-145
          animation-name: move-frames-145
  -webkit-animation-duration: 36804ms
          animation-duration: 36804ms
  -webkit-animation-delay: 30206ms
          animation-delay: 30206ms

@-webkit-keyframes move-frames-145 
  from 
    -webkit-transform: translate3d(16vw, 102vh, 0)
            transform: translate3d(16vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -126vh, 0)
            transform: translate3d(50vw, -126vh, 0)
  

@keyframes move-frames-145 
  from 
    -webkit-transform: translate3d(16vw, 102vh, 0)
            transform: translate3d(16vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -126vh, 0)
            transform: translate3d(50vw, -126vh, 0)
  

.circle-container:nth-child(145) .circle 
  -webkit-animation-delay: 3418ms
          animation-delay: 3418ms

.circle-container:nth-child(146) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-146
          animation-name: move-frames-146
  -webkit-animation-duration: 32905ms
          animation-duration: 32905ms
  -webkit-animation-delay: 31177ms
          animation-delay: 31177ms

@-webkit-keyframes move-frames-146 
  from 
    -webkit-transform: translate3d(99vw, 103vh, 0)
            transform: translate3d(99vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(55vw, -122vh, 0)
            transform: translate3d(55vw, -122vh, 0)
  

@keyframes move-frames-146 
  from 
    -webkit-transform: translate3d(99vw, 103vh, 0)
            transform: translate3d(99vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(55vw, -122vh, 0)
            transform: translate3d(55vw, -122vh, 0)
  

.circle-container:nth-child(146) .circle 
  -webkit-animation-delay: 2237ms
          animation-delay: 2237ms

.circle-container:nth-child(147) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-147
          animation-name: move-frames-147
  -webkit-animation-duration: 30465ms
          animation-duration: 30465ms
  -webkit-animation-delay: 35242ms
          animation-delay: 35242ms

@-webkit-keyframes move-frames-147 
  from 
    -webkit-transform: translate3d(90vw, 105vh, 0)
            transform: translate3d(90vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -106vh, 0)
            transform: translate3d(76vw, -106vh, 0)
  

@keyframes move-frames-147 
  from 
    -webkit-transform: translate3d(90vw, 105vh, 0)
            transform: translate3d(90vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(76vw, -106vh, 0)
            transform: translate3d(76vw, -106vh, 0)
  

.circle-container:nth-child(147) .circle 
  -webkit-animation-delay: 3840ms
          animation-delay: 3840ms

.circle-container:nth-child(148) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-148
          animation-name: move-frames-148
  -webkit-animation-duration: 32763ms
          animation-duration: 32763ms
  -webkit-animation-delay: 3868ms
          animation-delay: 3868ms

@-webkit-keyframes move-frames-148 
  from 
    -webkit-transform: translate3d(21vw, 109vh, 0)
            transform: translate3d(21vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(79vw, -111vh, 0)
            transform: translate3d(79vw, -111vh, 0)
  

@keyframes move-frames-148 
  from 
    -webkit-transform: translate3d(21vw, 109vh, 0)
            transform: translate3d(21vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(79vw, -111vh, 0)
            transform: translate3d(79vw, -111vh, 0)
  

.circle-container:nth-child(148) .circle 
  -webkit-animation-delay: 771ms
          animation-delay: 771ms

.circle-container:nth-child(149) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-149
          animation-name: move-frames-149
  -webkit-animation-duration: 35135ms
          animation-duration: 35135ms
  -webkit-animation-delay: 16248ms
          animation-delay: 16248ms

@-webkit-keyframes move-frames-149 
  from 
    -webkit-transform: translate3d(26vw, 107vh, 0)
            transform: translate3d(26vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(63vw, -125vh, 0)
            transform: translate3d(63vw, -125vh, 0)
  

@keyframes move-frames-149 
  from 
    -webkit-transform: translate3d(26vw, 107vh, 0)
            transform: translate3d(26vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(63vw, -125vh, 0)
            transform: translate3d(63vw, -125vh, 0)
  

.circle-container:nth-child(149) .circle 
  -webkit-animation-delay: 3464ms
          animation-delay: 3464ms

.circle-container:nth-child(150) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-150
          animation-name: move-frames-150
  -webkit-animation-duration: 36576ms
          animation-duration: 36576ms
  -webkit-animation-delay: 31573ms
          animation-delay: 31573ms

@-webkit-keyframes move-frames-150 
  from 
    -webkit-transform: translate3d(42vw, 103vh, 0)
            transform: translate3d(42vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(1vw, -108vh, 0)
            transform: translate3d(1vw, -108vh, 0)
  

@keyframes move-frames-150 
  from 
    -webkit-transform: translate3d(42vw, 103vh, 0)
            transform: translate3d(42vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(1vw, -108vh, 0)
            transform: translate3d(1vw, -108vh, 0)
  

.circle-container:nth-child(150) .circle 
  -webkit-animation-delay: 2457ms
          animation-delay: 2457ms

.circle-container:nth-child(151) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-151
          animation-name: move-frames-151
  -webkit-animation-duration: 31514ms
          animation-duration: 31514ms
  -webkit-animation-delay: 28475ms
          animation-delay: 28475ms

@-webkit-keyframes move-frames-151 
  from 
    -webkit-transform: translate3d(26vw, 103vh, 0)
            transform: translate3d(26vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(97vw, -115vh, 0)
            transform: translate3d(97vw, -115vh, 0)
  

@keyframes move-frames-151 
  from 
    -webkit-transform: translate3d(26vw, 103vh, 0)
            transform: translate3d(26vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(97vw, -115vh, 0)
            transform: translate3d(97vw, -115vh, 0)
  

.circle-container:nth-child(151) .circle 
  -webkit-animation-delay: 2395ms
          animation-delay: 2395ms

.circle-container:nth-child(152) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-152
          animation-name: move-frames-152
  -webkit-animation-duration: 29247ms
          animation-duration: 29247ms
  -webkit-animation-delay: 35735ms
          animation-delay: 35735ms

@-webkit-keyframes move-frames-152 
  from 
    -webkit-transform: translate3d(57vw, 110vh, 0)
            transform: translate3d(57vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(38vw, -121vh, 0)
            transform: translate3d(38vw, -121vh, 0)
  

@keyframes move-frames-152 
  from 
    -webkit-transform: translate3d(57vw, 110vh, 0)
            transform: translate3d(57vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(38vw, -121vh, 0)
            transform: translate3d(38vw, -121vh, 0)
  

.circle-container:nth-child(152) .circle 
  -webkit-animation-delay: 1648ms
          animation-delay: 1648ms

.circle-container:nth-child(153) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-153
          animation-name: move-frames-153
  -webkit-animation-duration: 35424ms
          animation-duration: 35424ms
  -webkit-animation-delay: 31880ms
          animation-delay: 31880ms

@-webkit-keyframes move-frames-153 
  from 
    -webkit-transform: translate3d(36vw, 103vh, 0)
            transform: translate3d(36vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(94vw, -133vh, 0)
            transform: translate3d(94vw, -133vh, 0)
  

@keyframes move-frames-153 
  from 
    -webkit-transform: translate3d(36vw, 103vh, 0)
            transform: translate3d(36vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(94vw, -133vh, 0)
            transform: translate3d(94vw, -133vh, 0)
  

.circle-container:nth-child(153) .circle 
  -webkit-animation-delay: 670ms
          animation-delay: 670ms

.circle-container:nth-child(154) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-154
          animation-name: move-frames-154
  -webkit-animation-duration: 30401ms
          animation-duration: 30401ms
  -webkit-animation-delay: 20780ms
          animation-delay: 20780ms

@-webkit-keyframes move-frames-154 
  from 
    -webkit-transform: translate3d(85vw, 110vh, 0)
            transform: translate3d(85vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(40vw, -120vh, 0)
            transform: translate3d(40vw, -120vh, 0)
  

@keyframes move-frames-154 
  from 
    -webkit-transform: translate3d(85vw, 110vh, 0)
            transform: translate3d(85vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(40vw, -120vh, 0)
            transform: translate3d(40vw, -120vh, 0)
  

.circle-container:nth-child(154) .circle 
  -webkit-animation-delay: 2488ms
          animation-delay: 2488ms

.circle-container:nth-child(155) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-155
          animation-name: move-frames-155
  -webkit-animation-duration: 36060ms
          animation-duration: 36060ms
  -webkit-animation-delay: 22428ms
          animation-delay: 22428ms

@-webkit-keyframes move-frames-155 
  from 
    -webkit-transform: translate3d(87vw, 102vh, 0)
            transform: translate3d(87vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -104vh, 0)
            transform: translate3d(95vw, -104vh, 0)
  

@keyframes move-frames-155 
  from 
    -webkit-transform: translate3d(87vw, 102vh, 0)
            transform: translate3d(87vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -104vh, 0)
            transform: translate3d(95vw, -104vh, 0)
  

.circle-container:nth-child(155) .circle 
  -webkit-animation-delay: 558ms
          animation-delay: 558ms

.circle-container:nth-child(156) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-156
          animation-name: move-frames-156
  -webkit-animation-duration: 35259ms
          animation-duration: 35259ms
  -webkit-animation-delay: 7394ms
          animation-delay: 7394ms

@-webkit-keyframes move-frames-156 
  from 
    -webkit-transform: translate3d(37vw, 107vh, 0)
            transform: translate3d(37vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -125vh, 0)
            transform: translate3d(47vw, -125vh, 0)
  

@keyframes move-frames-156 
  from 
    -webkit-transform: translate3d(37vw, 107vh, 0)
            transform: translate3d(37vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -125vh, 0)
            transform: translate3d(47vw, -125vh, 0)
  

.circle-container:nth-child(156) .circle 
  -webkit-animation-delay: 2827ms
          animation-delay: 2827ms

.circle-container:nth-child(157) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-157
          animation-name: move-frames-157
  -webkit-animation-duration: 28862ms
          animation-duration: 28862ms
  -webkit-animation-delay: 13057ms
          animation-delay: 13057ms

@-webkit-keyframes move-frames-157 
  from 
    -webkit-transform: translate3d(81vw, 104vh, 0)
            transform: translate3d(81vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -133vh, 0)
            transform: translate3d(75vw, -133vh, 0)
  

@keyframes move-frames-157 
  from 
    -webkit-transform: translate3d(81vw, 104vh, 0)
            transform: translate3d(81vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -133vh, 0)
            transform: translate3d(75vw, -133vh, 0)
  

.circle-container:nth-child(157) .circle 
  -webkit-animation-delay: 3553ms
          animation-delay: 3553ms

.circle-container:nth-child(158) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-158
          animation-name: move-frames-158
  -webkit-animation-duration: 31883ms
          animation-duration: 31883ms
  -webkit-animation-delay: 1735ms
          animation-delay: 1735ms

@-webkit-keyframes move-frames-158 
  from 
    -webkit-transform: translate3d(45vw, 110vh, 0)
            transform: translate3d(45vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -113vh, 0)
            transform: translate3d(50vw, -113vh, 0)
  

@keyframes move-frames-158 
  from 
    -webkit-transform: translate3d(45vw, 110vh, 0)
            transform: translate3d(45vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(50vw, -113vh, 0)
            transform: translate3d(50vw, -113vh, 0)
  

.circle-container:nth-child(158) .circle 
  -webkit-animation-delay: 1304ms
          animation-delay: 1304ms

.circle-container:nth-child(159) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-159
          animation-name: move-frames-159
  -webkit-animation-duration: 35017ms
          animation-duration: 35017ms
  -webkit-animation-delay: 34567ms
          animation-delay: 34567ms

@-webkit-keyframes move-frames-159 
  from 
    -webkit-transform: translate3d(54vw, 106vh, 0)
            transform: translate3d(54vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(92vw, -129vh, 0)
            transform: translate3d(92vw, -129vh, 0)
  

@keyframes move-frames-159 
  from 
    -webkit-transform: translate3d(54vw, 106vh, 0)
            transform: translate3d(54vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(92vw, -129vh, 0)
            transform: translate3d(92vw, -129vh, 0)
  

.circle-container:nth-child(159) .circle 
  -webkit-animation-delay: 2565ms
          animation-delay: 2565ms

.circle-container:nth-child(160) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-160
          animation-name: move-frames-160
  -webkit-animation-duration: 29248ms
          animation-duration: 29248ms
  -webkit-animation-delay: 34067ms
          animation-delay: 34067ms

@-webkit-keyframes move-frames-160 
  from 
    -webkit-transform: translate3d(51vw, 107vh, 0)
            transform: translate3d(51vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(23vw, -128vh, 0)
            transform: translate3d(23vw, -128vh, 0)
  

@keyframes move-frames-160 
  from 
    -webkit-transform: translate3d(51vw, 107vh, 0)
            transform: translate3d(51vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(23vw, -128vh, 0)
            transform: translate3d(23vw, -128vh, 0)
  

.circle-container:nth-child(160) .circle 
  -webkit-animation-delay: 65ms
          animation-delay: 65ms

.circle-container:nth-child(161) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-161
          animation-name: move-frames-161
  -webkit-animation-duration: 37000ms
          animation-duration: 37000ms
  -webkit-animation-delay: 57ms
          animation-delay: 57ms

@-webkit-keyframes move-frames-161 
  from 
    -webkit-transform: translate3d(61vw, 104vh, 0)
            transform: translate3d(61vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -126vh, 0)
            transform: translate3d(68vw, -126vh, 0)
  

@keyframes move-frames-161 
  from 
    -webkit-transform: translate3d(61vw, 104vh, 0)
            transform: translate3d(61vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -126vh, 0)
            transform: translate3d(68vw, -126vh, 0)
  

.circle-container:nth-child(161) .circle 
  -webkit-animation-delay: 2944ms
          animation-delay: 2944ms

.circle-container:nth-child(162) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-162
          animation-name: move-frames-162
  -webkit-animation-duration: 36662ms
          animation-duration: 36662ms
  -webkit-animation-delay: 2003ms
          animation-delay: 2003ms

@-webkit-keyframes move-frames-162 
  from 
    -webkit-transform: translate3d(36vw, 105vh, 0)
            transform: translate3d(36vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -129vh, 0)
            transform: translate3d(68vw, -129vh, 0)
  

@keyframes move-frames-162 
  from 
    -webkit-transform: translate3d(36vw, 105vh, 0)
            transform: translate3d(36vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(68vw, -129vh, 0)
            transform: translate3d(68vw, -129vh, 0)
  

.circle-container:nth-child(162) .circle 
  -webkit-animation-delay: 3403ms
          animation-delay: 3403ms

.circle-container:nth-child(163) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-163
          animation-name: move-frames-163
  -webkit-animation-duration: 28218ms
          animation-duration: 28218ms
  -webkit-animation-delay: 32366ms
          animation-delay: 32366ms

@-webkit-keyframes move-frames-163 
  from 
    -webkit-transform: translate3d(84vw, 103vh, 0)
            transform: translate3d(84vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(89vw, -109vh, 0)
            transform: translate3d(89vw, -109vh, 0)
  

@keyframes move-frames-163 
  from 
    -webkit-transform: translate3d(84vw, 103vh, 0)
            transform: translate3d(84vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(89vw, -109vh, 0)
            transform: translate3d(89vw, -109vh, 0)
  

.circle-container:nth-child(163) .circle 
  -webkit-animation-delay: 951ms
          animation-delay: 951ms

.circle-container:nth-child(164) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-164
          animation-name: move-frames-164
  -webkit-animation-duration: 33033ms
          animation-duration: 33033ms
  -webkit-animation-delay: 17223ms
          animation-delay: 17223ms

@-webkit-keyframes move-frames-164 
  from 
    -webkit-transform: translate3d(26vw, 108vh, 0)
            transform: translate3d(26vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -126vh, 0)
            transform: translate3d(75vw, -126vh, 0)
  

@keyframes move-frames-164 
  from 
    -webkit-transform: translate3d(26vw, 108vh, 0)
            transform: translate3d(26vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -126vh, 0)
            transform: translate3d(75vw, -126vh, 0)
  

.circle-container:nth-child(164) .circle 
  -webkit-animation-delay: 924ms
          animation-delay: 924ms

.circle-container:nth-child(165) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-165
          animation-name: move-frames-165
  -webkit-animation-duration: 35337ms
          animation-duration: 35337ms
  -webkit-animation-delay: 8523ms
          animation-delay: 8523ms

@-webkit-keyframes move-frames-165 
  from 
    -webkit-transform: translate3d(68vw, 109vh, 0)
            transform: translate3d(68vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -112vh, 0)
            transform: translate3d(42vw, -112vh, 0)
  

@keyframes move-frames-165 
  from 
    -webkit-transform: translate3d(68vw, 109vh, 0)
            transform: translate3d(68vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -112vh, 0)
            transform: translate3d(42vw, -112vh, 0)
  

.circle-container:nth-child(165) .circle 
  -webkit-animation-delay: 3713ms
          animation-delay: 3713ms

.circle-container:nth-child(166) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-166
          animation-name: move-frames-166
  -webkit-animation-duration: 28610ms
          animation-duration: 28610ms
  -webkit-animation-delay: 20279ms
          animation-delay: 20279ms

@-webkit-keyframes move-frames-166 
  from 
    -webkit-transform: translate3d(69vw, 110vh, 0)
            transform: translate3d(69vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -126vh, 0)
            transform: translate3d(95vw, -126vh, 0)
  

@keyframes move-frames-166 
  from 
    -webkit-transform: translate3d(69vw, 110vh, 0)
            transform: translate3d(69vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(95vw, -126vh, 0)
            transform: translate3d(95vw, -126vh, 0)
  

.circle-container:nth-child(166) .circle 
  -webkit-animation-delay: 3050ms
          animation-delay: 3050ms

.circle-container:nth-child(167) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-167
          animation-name: move-frames-167
  -webkit-animation-duration: 32644ms
          animation-duration: 32644ms
  -webkit-animation-delay: 19021ms
          animation-delay: 19021ms

@-webkit-keyframes move-frames-167 
  from 
    -webkit-transform: translate3d(95vw, 107vh, 0)
            transform: translate3d(95vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(98vw, -127vh, 0)
            transform: translate3d(98vw, -127vh, 0)
  

@keyframes move-frames-167 
  from 
    -webkit-transform: translate3d(95vw, 107vh, 0)
            transform: translate3d(95vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(98vw, -127vh, 0)
            transform: translate3d(98vw, -127vh, 0)
  

.circle-container:nth-child(167) .circle 
  -webkit-animation-delay: 371ms
          animation-delay: 371ms

.circle-container:nth-child(168) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-168
          animation-name: move-frames-168
  -webkit-animation-duration: 28598ms
          animation-duration: 28598ms
  -webkit-animation-delay: 31850ms
          animation-delay: 31850ms

@-webkit-keyframes move-frames-168 
  from 
    -webkit-transform: translate3d(56vw, 110vh, 0)
            transform: translate3d(56vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(21vw, -111vh, 0)
            transform: translate3d(21vw, -111vh, 0)
  

@keyframes move-frames-168 
  from 
    -webkit-transform: translate3d(56vw, 110vh, 0)
            transform: translate3d(56vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(21vw, -111vh, 0)
            transform: translate3d(21vw, -111vh, 0)
  

.circle-container:nth-child(168) .circle 
  -webkit-animation-delay: 998ms
          animation-delay: 998ms

.circle-container:nth-child(169) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-169
          animation-name: move-frames-169
  -webkit-animation-duration: 32894ms
          animation-duration: 32894ms
  -webkit-animation-delay: 14484ms
          animation-delay: 14484ms

@-webkit-keyframes move-frames-169 
  from 
    -webkit-transform: translate3d(91vw, 103vh, 0)
            transform: translate3d(91vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -125vh, 0)
            transform: translate3d(30vw, -125vh, 0)
  

@keyframes move-frames-169 
  from 
    -webkit-transform: translate3d(91vw, 103vh, 0)
            transform: translate3d(91vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -125vh, 0)
            transform: translate3d(30vw, -125vh, 0)
  

.circle-container:nth-child(169) .circle 
  -webkit-animation-delay: 1239ms
          animation-delay: 1239ms

.circle-container:nth-child(170) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-170
          animation-name: move-frames-170
  -webkit-animation-duration: 33126ms
          animation-duration: 33126ms
  -webkit-animation-delay: 16899ms
          animation-delay: 16899ms

@-webkit-keyframes move-frames-170 
  from 
    -webkit-transform: translate3d(22vw, 104vh, 0)
            transform: translate3d(22vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(24vw, -119vh, 0)
            transform: translate3d(24vw, -119vh, 0)
  

@keyframes move-frames-170 
  from 
    -webkit-transform: translate3d(22vw, 104vh, 0)
            transform: translate3d(22vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(24vw, -119vh, 0)
            transform: translate3d(24vw, -119vh, 0)
  

.circle-container:nth-child(170) .circle 
  -webkit-animation-delay: 397ms
          animation-delay: 397ms

.circle-container:nth-child(171) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-171
          animation-name: move-frames-171
  -webkit-animation-duration: 33724ms
          animation-duration: 33724ms
  -webkit-animation-delay: 21328ms
          animation-delay: 21328ms

@-webkit-keyframes move-frames-171 
  from 
    -webkit-transform: translate3d(32vw, 106vh, 0)
            transform: translate3d(32vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -129vh, 0)
            transform: translate3d(3vw, -129vh, 0)
  

@keyframes move-frames-171 
  from 
    -webkit-transform: translate3d(32vw, 106vh, 0)
            transform: translate3d(32vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -129vh, 0)
            transform: translate3d(3vw, -129vh, 0)
  

.circle-container:nth-child(171) .circle 
  -webkit-animation-delay: 1097ms
          animation-delay: 1097ms

.circle-container:nth-child(172) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-172
          animation-name: move-frames-172
  -webkit-animation-duration: 35704ms
          animation-duration: 35704ms
  -webkit-animation-delay: 6212ms
          animation-delay: 6212ms

@-webkit-keyframes move-frames-172 
  from 
    -webkit-transform: translate3d(33vw, 110vh, 0)
            transform: translate3d(33vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -122vh, 0)
            transform: translate3d(3vw, -122vh, 0)
  

@keyframes move-frames-172 
  from 
    -webkit-transform: translate3d(33vw, 110vh, 0)
            transform: translate3d(33vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(3vw, -122vh, 0)
            transform: translate3d(3vw, -122vh, 0)
  

.circle-container:nth-child(172) .circle 
  -webkit-animation-delay: 524ms
          animation-delay: 524ms

.circle-container:nth-child(173) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-173
          animation-name: move-frames-173
  -webkit-animation-duration: 28633ms
          animation-duration: 28633ms
  -webkit-animation-delay: 2161ms
          animation-delay: 2161ms

@-webkit-keyframes move-frames-173 
  from 
    -webkit-transform: translate3d(68vw, 105vh, 0)
            transform: translate3d(68vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -117vh, 0)
            transform: translate3d(87vw, -117vh, 0)
  

@keyframes move-frames-173 
  from 
    -webkit-transform: translate3d(68vw, 105vh, 0)
            transform: translate3d(68vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(87vw, -117vh, 0)
            transform: translate3d(87vw, -117vh, 0)
  

.circle-container:nth-child(173) .circle 
  -webkit-animation-delay: 550ms
          animation-delay: 550ms

.circle-container:nth-child(174) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-174
          animation-name: move-frames-174
  -webkit-animation-duration: 29116ms
          animation-duration: 29116ms
  -webkit-animation-delay: 31594ms
          animation-delay: 31594ms

@-webkit-keyframes move-frames-174 
  from 
    -webkit-transform: translate3d(96vw, 102vh, 0)
            transform: translate3d(96vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(96vw, -117vh, 0)
            transform: translate3d(96vw, -117vh, 0)
  

@keyframes move-frames-174 
  from 
    -webkit-transform: translate3d(96vw, 102vh, 0)
            transform: translate3d(96vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(96vw, -117vh, 0)
            transform: translate3d(96vw, -117vh, 0)
  

.circle-container:nth-child(174) .circle 
  -webkit-animation-delay: 1701ms
          animation-delay: 1701ms

.circle-container:nth-child(175) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-175
          animation-name: move-frames-175
  -webkit-animation-duration: 35479ms
          animation-duration: 35479ms
  -webkit-animation-delay: 15883ms
          animation-delay: 15883ms

@-webkit-keyframes move-frames-175 
  from 
    -webkit-transform: translate3d(85vw, 107vh, 0)
            transform: translate3d(85vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -110vh, 0)
            transform: translate3d(34vw, -110vh, 0)
  

@keyframes move-frames-175 
  from 
    -webkit-transform: translate3d(85vw, 107vh, 0)
            transform: translate3d(85vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -110vh, 0)
            transform: translate3d(34vw, -110vh, 0)
  

.circle-container:nth-child(175) .circle 
  -webkit-animation-delay: 639ms
          animation-delay: 639ms

.circle-container:nth-child(176) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-176
          animation-name: move-frames-176
  -webkit-animation-duration: 30678ms
          animation-duration: 30678ms
  -webkit-animation-delay: 2780ms
          animation-delay: 2780ms

@-webkit-keyframes move-frames-176 
  from 
    -webkit-transform: translate3d(39vw, 107vh, 0)
            transform: translate3d(39vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -125vh, 0)
            transform: translate3d(47vw, -125vh, 0)
  

@keyframes move-frames-176 
  from 
    -webkit-transform: translate3d(39vw, 107vh, 0)
            transform: translate3d(39vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(47vw, -125vh, 0)
            transform: translate3d(47vw, -125vh, 0)
  

.circle-container:nth-child(176) .circle 
  -webkit-animation-delay: 1819ms
          animation-delay: 1819ms

.circle-container:nth-child(177) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-177
          animation-name: move-frames-177
  -webkit-animation-duration: 35096ms
          animation-duration: 35096ms
  -webkit-animation-delay: 32060ms
          animation-delay: 32060ms

@-webkit-keyframes move-frames-177 
  from 
    -webkit-transform: translate3d(56vw, 109vh, 0)
            transform: translate3d(56vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(65vw, -138vh, 0)
            transform: translate3d(65vw, -138vh, 0)
  

@keyframes move-frames-177 
  from 
    -webkit-transform: translate3d(56vw, 109vh, 0)
            transform: translate3d(56vw, 109vh, 0)
  
  to 
    -webkit-transform: translate3d(65vw, -138vh, 0)
            transform: translate3d(65vw, -138vh, 0)
  

.circle-container:nth-child(177) .circle 
  -webkit-animation-delay: 3099ms
          animation-delay: 3099ms

.circle-container:nth-child(178) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-178
          animation-name: move-frames-178
  -webkit-animation-duration: 36991ms
          animation-duration: 36991ms
  -webkit-animation-delay: 22168ms
          animation-delay: 22168ms

@-webkit-keyframes move-frames-178 
  from 
    -webkit-transform: translate3d(94vw, 108vh, 0)
            transform: translate3d(94vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(7vw, -122vh, 0)
            transform: translate3d(7vw, -122vh, 0)
  

@keyframes move-frames-178 
  from 
    -webkit-transform: translate3d(94vw, 108vh, 0)
            transform: translate3d(94vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(7vw, -122vh, 0)
            transform: translate3d(7vw, -122vh, 0)
  

.circle-container:nth-child(178) .circle 
  -webkit-animation-delay: 2960ms
          animation-delay: 2960ms

.circle-container:nth-child(179) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-179
          animation-name: move-frames-179
  -webkit-animation-duration: 33294ms
          animation-duration: 33294ms
  -webkit-animation-delay: 2337ms
          animation-delay: 2337ms

@-webkit-keyframes move-frames-179 
  from 
    -webkit-transform: translate3d(63vw, 103vh, 0)
            transform: translate3d(63vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(29vw, -123vh, 0)
            transform: translate3d(29vw, -123vh, 0)
  

@keyframes move-frames-179 
  from 
    -webkit-transform: translate3d(63vw, 103vh, 0)
            transform: translate3d(63vw, 103vh, 0)
  
  to 
    -webkit-transform: translate3d(29vw, -123vh, 0)
            transform: translate3d(29vw, -123vh, 0)
  

.circle-container:nth-child(179) .circle 
  -webkit-animation-delay: 2221ms
          animation-delay: 2221ms

.circle-container:nth-child(180) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-180
          animation-name: move-frames-180
  -webkit-animation-duration: 30076ms
          animation-duration: 30076ms
  -webkit-animation-delay: 29094ms
          animation-delay: 29094ms

@-webkit-keyframes move-frames-180 
  from 
    -webkit-transform: translate3d(78vw, 108vh, 0)
            transform: translate3d(78vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(72vw, -133vh, 0)
            transform: translate3d(72vw, -133vh, 0)
  

@keyframes move-frames-180 
  from 
    -webkit-transform: translate3d(78vw, 108vh, 0)
            transform: translate3d(78vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(72vw, -133vh, 0)
            transform: translate3d(72vw, -133vh, 0)
  

.circle-container:nth-child(180) .circle 
  -webkit-animation-delay: 1902ms
          animation-delay: 1902ms

.circle-container:nth-child(181) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-181
          animation-name: move-frames-181
  -webkit-animation-duration: 30451ms
          animation-duration: 30451ms
  -webkit-animation-delay: 12539ms
          animation-delay: 12539ms

@-webkit-keyframes move-frames-181 
  from 
    -webkit-transform: translate3d(67vw, 106vh, 0)
            transform: translate3d(67vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -107vh, 0)
            transform: translate3d(30vw, -107vh, 0)
  

@keyframes move-frames-181 
  from 
    -webkit-transform: translate3d(67vw, 106vh, 0)
            transform: translate3d(67vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -107vh, 0)
            transform: translate3d(30vw, -107vh, 0)
  

.circle-container:nth-child(181) .circle 
  -webkit-animation-delay: 2088ms
          animation-delay: 2088ms

.circle-container:nth-child(182) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-182
          animation-name: move-frames-182
  -webkit-animation-duration: 32230ms
          animation-duration: 32230ms
  -webkit-animation-delay: 9888ms
          animation-delay: 9888ms

@-webkit-keyframes move-frames-182 
  from 
    -webkit-transform: translate3d(68vw, 110vh, 0)
            transform: translate3d(68vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -131vh, 0)
            transform: translate3d(34vw, -131vh, 0)
  

@keyframes move-frames-182 
  from 
    -webkit-transform: translate3d(68vw, 110vh, 0)
            transform: translate3d(68vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -131vh, 0)
            transform: translate3d(34vw, -131vh, 0)
  

.circle-container:nth-child(182) .circle 
  -webkit-animation-delay: 3127ms
          animation-delay: 3127ms

.circle-container:nth-child(183) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-183
          animation-name: move-frames-183
  -webkit-animation-duration: 30492ms
          animation-duration: 30492ms
  -webkit-animation-delay: 2980ms
          animation-delay: 2980ms

@-webkit-keyframes move-frames-183 
  from 
    -webkit-transform: translate3d(89vw, 107vh, 0)
            transform: translate3d(89vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(55vw, -109vh, 0)
            transform: translate3d(55vw, -109vh, 0)
  

@keyframes move-frames-183 
  from 
    -webkit-transform: translate3d(89vw, 107vh, 0)
            transform: translate3d(89vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(55vw, -109vh, 0)
            transform: translate3d(55vw, -109vh, 0)
  

.circle-container:nth-child(183) .circle 
  -webkit-animation-delay: 2236ms
          animation-delay: 2236ms

.circle-container:nth-child(184) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-184
          animation-name: move-frames-184
  -webkit-animation-duration: 33141ms
          animation-duration: 33141ms
  -webkit-animation-delay: 28307ms
          animation-delay: 28307ms

@-webkit-keyframes move-frames-184 
  from 
    -webkit-transform: translate3d(11vw, 107vh, 0)
            transform: translate3d(11vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(44vw, -111vh, 0)
            transform: translate3d(44vw, -111vh, 0)
  

@keyframes move-frames-184 
  from 
    -webkit-transform: translate3d(11vw, 107vh, 0)
            transform: translate3d(11vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(44vw, -111vh, 0)
            transform: translate3d(44vw, -111vh, 0)
  

.circle-container:nth-child(184) .circle 
  -webkit-animation-delay: 522ms
          animation-delay: 522ms

.circle-container:nth-child(185) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-185
          animation-name: move-frames-185
  -webkit-animation-duration: 29697ms
          animation-duration: 29697ms
  -webkit-animation-delay: 2809ms
          animation-delay: 2809ms

@-webkit-keyframes move-frames-185 
  from 
    -webkit-transform: translate3d(44vw, 102vh, 0)
            transform: translate3d(44vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -117vh, 0)
            transform: translate3d(34vw, -117vh, 0)
  

@keyframes move-frames-185 
  from 
    -webkit-transform: translate3d(44vw, 102vh, 0)
            transform: translate3d(44vw, 102vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -117vh, 0)
            transform: translate3d(34vw, -117vh, 0)
  

.circle-container:nth-child(185) .circle 
  -webkit-animation-delay: 3300ms
          animation-delay: 3300ms

.circle-container:nth-child(186) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-186
          animation-name: move-frames-186
  -webkit-animation-duration: 30331ms
          animation-duration: 30331ms
  -webkit-animation-delay: 15486ms
          animation-delay: 15486ms

@-webkit-keyframes move-frames-186 
  from 
    -webkit-transform: translate3d(52vw, 110vh, 0)
            transform: translate3d(52vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -122vh, 0)
            transform: translate3d(31vw, -122vh, 0)
  

@keyframes move-frames-186 
  from 
    -webkit-transform: translate3d(52vw, 110vh, 0)
            transform: translate3d(52vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(31vw, -122vh, 0)
            transform: translate3d(31vw, -122vh, 0)
  

.circle-container:nth-child(186) .circle 
  -webkit-animation-delay: 2996ms
          animation-delay: 2996ms

.circle-container:nth-child(187) 
  width: 3px
  height: 3px
  -webkit-animation-name: move-frames-187
          animation-name: move-frames-187
  -webkit-animation-duration: 36511ms
          animation-duration: 36511ms
  -webkit-animation-delay: 26123ms
          animation-delay: 26123ms

@-webkit-keyframes move-frames-187 
  from 
    -webkit-transform: translate3d(83vw, 110vh, 0)
            transform: translate3d(83vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(71vw, -132vh, 0)
            transform: translate3d(71vw, -132vh, 0)
  

@keyframes move-frames-187 
  from 
    -webkit-transform: translate3d(83vw, 110vh, 0)
            transform: translate3d(83vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(71vw, -132vh, 0)
            transform: translate3d(71vw, -132vh, 0)
  

.circle-container:nth-child(187) .circle 
  -webkit-animation-delay: 2437ms
          animation-delay: 2437ms

.circle-container:nth-child(188) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-188
          animation-name: move-frames-188
  -webkit-animation-duration: 35003ms
          animation-duration: 35003ms
  -webkit-animation-delay: 14307ms
          animation-delay: 14307ms

@-webkit-keyframes move-frames-188 
  from 
    -webkit-transform: translate3d(73vw, 108vh, 0)
            transform: translate3d(73vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -122vh, 0)
            transform: translate3d(42vw, -122vh, 0)
  

@keyframes move-frames-188 
  from 
    -webkit-transform: translate3d(73vw, 108vh, 0)
            transform: translate3d(73vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(42vw, -122vh, 0)
            transform: translate3d(42vw, -122vh, 0)
  

.circle-container:nth-child(188) .circle 
  -webkit-animation-delay: 2599ms
          animation-delay: 2599ms

.circle-container:nth-child(189) 
  width: 5px
  height: 5px
  -webkit-animation-name: move-frames-189
          animation-name: move-frames-189
  -webkit-animation-duration: 34033ms
          animation-duration: 34033ms
  -webkit-animation-delay: 3071ms
          animation-delay: 3071ms

@-webkit-keyframes move-frames-189 
  from 
    -webkit-transform: translate3d(78vw, 104vh, 0)
            transform: translate3d(78vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(29vw, -123vh, 0)
            transform: translate3d(29vw, -123vh, 0)
  

@keyframes move-frames-189 
  from 
    -webkit-transform: translate3d(78vw, 104vh, 0)
            transform: translate3d(78vw, 104vh, 0)
  
  to 
    -webkit-transform: translate3d(29vw, -123vh, 0)
            transform: translate3d(29vw, -123vh, 0)
  

.circle-container:nth-child(189) .circle 
  -webkit-animation-delay: 2856ms
          animation-delay: 2856ms

.circle-container:nth-child(190) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-190
          animation-name: move-frames-190
  -webkit-animation-duration: 33696ms
          animation-duration: 33696ms
  -webkit-animation-delay: 22301ms
          animation-delay: 22301ms

@-webkit-keyframes move-frames-190 
  from 
    -webkit-transform: translate3d(92vw, 110vh, 0)
            transform: translate3d(92vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(4vw, -123vh, 0)
            transform: translate3d(4vw, -123vh, 0)
  

@keyframes move-frames-190 
  from 
    -webkit-transform: translate3d(92vw, 110vh, 0)
            transform: translate3d(92vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(4vw, -123vh, 0)
            transform: translate3d(4vw, -123vh, 0)
  

.circle-container:nth-child(190) .circle 
  -webkit-animation-delay: 1011ms
          animation-delay: 1011ms

.circle-container:nth-child(191) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-191
          animation-name: move-frames-191
  -webkit-animation-duration: 35213ms
          animation-duration: 35213ms
  -webkit-animation-delay: 10125ms
          animation-delay: 10125ms

@-webkit-keyframes move-frames-191 
  from 
    -webkit-transform: translate3d(11vw, 105vh, 0)
            transform: translate3d(11vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -120vh, 0)
            transform: translate3d(30vw, -120vh, 0)
  

@keyframes move-frames-191 
  from 
    -webkit-transform: translate3d(11vw, 105vh, 0)
            transform: translate3d(11vw, 105vh, 0)
  
  to 
    -webkit-transform: translate3d(30vw, -120vh, 0)
            transform: translate3d(30vw, -120vh, 0)
  

.circle-container:nth-child(191) .circle 
  -webkit-animation-delay: 775ms
          animation-delay: 775ms

.circle-container:nth-child(192) 
  width: 6px
  height: 6px
  -webkit-animation-name: move-frames-192
          animation-name: move-frames-192
  -webkit-animation-duration: 32187ms
          animation-duration: 32187ms
  -webkit-animation-delay: 28104ms
          animation-delay: 28104ms

@-webkit-keyframes move-frames-192 
  from 
    -webkit-transform: translate3d(14vw, 107vh, 0)
            transform: translate3d(14vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(14vw, -122vh, 0)
            transform: translate3d(14vw, -122vh, 0)
  

@keyframes move-frames-192 
  from 
    -webkit-transform: translate3d(14vw, 107vh, 0)
            transform: translate3d(14vw, 107vh, 0)
  
  to 
    -webkit-transform: translate3d(14vw, -122vh, 0)
            transform: translate3d(14vw, -122vh, 0)
  

.circle-container:nth-child(192) .circle 
  -webkit-animation-delay: 134ms
          animation-delay: 134ms

.circle-container:nth-child(193) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-193
          animation-name: move-frames-193
  -webkit-animation-duration: 36080ms
          animation-duration: 36080ms
  -webkit-animation-delay: 19382ms
          animation-delay: 19382ms

@-webkit-keyframes move-frames-193 
  from 
    -webkit-transform: translate3d(44vw, 110vh, 0)
            transform: translate3d(44vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -122vh, 0)
            transform: translate3d(27vw, -122vh, 0)
  

@keyframes move-frames-193 
  from 
    -webkit-transform: translate3d(44vw, 110vh, 0)
            transform: translate3d(44vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(27vw, -122vh, 0)
            transform: translate3d(27vw, -122vh, 0)
  

.circle-container:nth-child(193) .circle 
  -webkit-animation-delay: 719ms
          animation-delay: 719ms

.circle-container:nth-child(194) 
  width: 4px
  height: 4px
  -webkit-animation-name: move-frames-194
          animation-name: move-frames-194
  -webkit-animation-duration: 34620ms
          animation-duration: 34620ms
  -webkit-animation-delay: 15166ms
          animation-delay: 15166ms

@-webkit-keyframes move-frames-194 
  from 
    -webkit-transform: translate3d(41vw, 110vh, 0)
            transform: translate3d(41vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(5vw, -115vh, 0)
            transform: translate3d(5vw, -115vh, 0)
  

@keyframes move-frames-194 
  from 
    -webkit-transform: translate3d(41vw, 110vh, 0)
            transform: translate3d(41vw, 110vh, 0)
  
  to 
    -webkit-transform: translate3d(5vw, -115vh, 0)
            transform: translate3d(5vw, -115vh, 0)
  

.circle-container:nth-child(194) .circle 
  -webkit-animation-delay: 2158ms
          animation-delay: 2158ms

.circle-container:nth-child(195) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-195
          animation-name: move-frames-195
  -webkit-animation-duration: 36944ms
          animation-duration: 36944ms
  -webkit-animation-delay: 17969ms
          animation-delay: 17969ms

@-webkit-keyframes move-frames-195 
  from 
    -webkit-transform: translate3d(60vw, 106vh, 0)
            transform: translate3d(60vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(24vw, -112vh, 0)
            transform: translate3d(24vw, -112vh, 0)
  

@keyframes move-frames-195 
  from 
    -webkit-transform: translate3d(60vw, 106vh, 0)
            transform: translate3d(60vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(24vw, -112vh, 0)
            transform: translate3d(24vw, -112vh, 0)
  

.circle-container:nth-child(195) .circle 
  -webkit-animation-delay: 3191ms
          animation-delay: 3191ms

.circle-container:nth-child(196) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-196
          animation-name: move-frames-196
  -webkit-animation-duration: 36246ms
          animation-duration: 36246ms
  -webkit-animation-delay: 15730ms
          animation-delay: 15730ms

@-webkit-keyframes move-frames-196 
  from 
    -webkit-transform: translate3d(12vw, 108vh, 0)
            transform: translate3d(12vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -109vh, 0)
            transform: translate3d(75vw, -109vh, 0)
  

@keyframes move-frames-196 
  from 
    -webkit-transform: translate3d(12vw, 108vh, 0)
            transform: translate3d(12vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(75vw, -109vh, 0)
            transform: translate3d(75vw, -109vh, 0)
  

.circle-container:nth-child(196) .circle 
  -webkit-animation-delay: 3809ms
          animation-delay: 3809ms

.circle-container:nth-child(197) 
  width: 7px
  height: 7px
  -webkit-animation-name: move-frames-197
          animation-name: move-frames-197
  -webkit-animation-duration: 29738ms
          animation-duration: 29738ms
  -webkit-animation-delay: 18752ms
          animation-delay: 18752ms

@-webkit-keyframes move-frames-197 
  from 
    -webkit-transform: translate3d(48vw, 106vh, 0)
            transform: translate3d(48vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -110vh, 0)
            transform: translate3d(41vw, -110vh, 0)
  

@keyframes move-frames-197 
  from 
    -webkit-transform: translate3d(48vw, 106vh, 0)
            transform: translate3d(48vw, 106vh, 0)
  
  to 
    -webkit-transform: translate3d(41vw, -110vh, 0)
            transform: translate3d(41vw, -110vh, 0)
  

.circle-container:nth-child(197) .circle 
  -webkit-animation-delay: 2958ms
          animation-delay: 2958ms

.circle-container:nth-child(198) 
  width: 2px
  height: 2px
  -webkit-animation-name: move-frames-198
          animation-name: move-frames-198
  -webkit-animation-duration: 28820ms
          animation-duration: 28820ms
  -webkit-animation-delay: 10352ms
          animation-delay: 10352ms

@-webkit-keyframes move-frames-198 
  from 
    -webkit-transform: translate3d(53vw, 101vh, 0)
            transform: translate3d(53vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -129vh, 0)
            transform: translate3d(34vw, -129vh, 0)
  

@keyframes move-frames-198 
  from 
    -webkit-transform: translate3d(53vw, 101vh, 0)
            transform: translate3d(53vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(34vw, -129vh, 0)
            transform: translate3d(34vw, -129vh, 0)
  

.circle-container:nth-child(198) .circle 
  -webkit-animation-delay: 2241ms
          animation-delay: 2241ms

.circle-container:nth-child(199) 
  width: 1px
  height: 1px
  -webkit-animation-name: move-frames-199
          animation-name: move-frames-199
  -webkit-animation-duration: 29811ms
          animation-duration: 29811ms
  -webkit-animation-delay: 30984ms
          animation-delay: 30984ms

@-webkit-keyframes move-frames-199 
  from 
    -webkit-transform: translate3d(3vw, 108vh, 0)
            transform: translate3d(3vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(54vw, -135vh, 0)
            transform: translate3d(54vw, -135vh, 0)
  

@keyframes move-frames-199 
  from 
    -webkit-transform: translate3d(3vw, 108vh, 0)
            transform: translate3d(3vw, 108vh, 0)
  
  to 
    -webkit-transform: translate3d(54vw, -135vh, 0)
            transform: translate3d(54vw, -135vh, 0)
  

.circle-container:nth-child(199) .circle 
  -webkit-animation-delay: 2627ms
          animation-delay: 2627ms

.circle-container:nth-child(200) 
  width: 8px
  height: 8px
  -webkit-animation-name: move-frames-200
          animation-name: move-frames-200
  -webkit-animation-duration: 29444ms
          animation-duration: 29444ms
  -webkit-animation-delay: 221ms
          animation-delay: 221ms

@-webkit-keyframes move-frames-200 
  from 
    -webkit-transform: translate3d(25vw, 101vh, 0)
            transform: translate3d(25vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(48vw, -131vh, 0)
            transform: translate3d(48vw, -131vh, 0)
  

@keyframes move-frames-200 
  from 
    -webkit-transform: translate3d(25vw, 101vh, 0)
            transform: translate3d(25vw, 101vh, 0)
  
  to 
    -webkit-transform: translate3d(48vw, -131vh, 0)
            transform: translate3d(48vw, -131vh, 0)
  

.circle-container:nth-child(200) .circle 
  -webkit-animation-delay: 3323ms
          animation-delay: 3323ms

</style>